<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar" @click="handleOutsideClick">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>
                    {{ constants.JOIN_OUR_TEAM_TEXT }}
                  </h1>
                  <div class="admin-page-type-links">
                    <ul>
                      <li>
                        <a
                          id="allLink"
                          href="#"
                          :class="{ active: activeTab === 'all' }"
                          @click="switchView('all')"
                        >
                          {{ constants.ALL_LINK }}
                          <span>{{ counts.all }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="newApplicationLink"
                          href="#"
                          :class="{ active: activeTab === 'hired' }"
                          @click="switchView('hired')"
                        >
                          {{ constants.HIRED_LINK }}
                          <span>{{ counts.hired }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="followUpLink"
                          href="#"
                          :class="{ active: activeTab === 'pending' }"
                          @click="switchView('pending')"
                        >
                          {{ constants.PENDING_LINK }}
                          <span>{{ counts.pending }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="rejectedLink"
                          href="#"
                          :class="{ active: activeTab === 'rejected' }"
                          @click="switchView('rejected')"
                        >
                          {{ constants.REJECTED_LINK }}
                          <span>{{ counts.rejected }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="admin-search-box">
                      <input
                        id="seachJoinTeamInput"
                        type="text"
                        placeholder="Search"
                        v-model="searchedText"
                        @keyup.enter="
                          fetchJoinTeams(activeTab),
                            fetchCounts(searchedText),
                            (editFormSubmitted = false),
                            (selectAll = false),
                            (selectedJoinTeams = []),
                            (selectAllCandidates = false)
                        "
                      />
                    </div>
                    <div
                      class="date-filter-box"
                      id="dateFilterDropdown"
                      :class="{ 'show-date-dropdown': showDateDropdown }"
                    >
                      <div class="date-filter-icon">
                        <button
                          id="dateFilterBtn" @click="toggleDateDropdown"
                          
                        >
                          <img
                            src="@/assets/images/admin-img/date-blue.svg"
                            alt=""
                          />
                        </button>
                      </div>
                      <div
                        class="date-filter-dropdown"
                        :class="{ 'show-custom-date': showCustomDate }"
                      >
                        <div class="date-filter-dropdown-in">
                          <a
                            href="#"
                            id="lastWeeekLink"
                            class="date-item"
                            @click="getDateFilteredData('lastWeek')"
                            >{{ constants.LAST_WEEK_LINK }}</a
                          >
                          <a
                            href="#"
                            id="lastMonthLink"
                            class="date-item"
                            @click="getDateFilteredData('lastMonth')"
                            >{{ constants.LAST_MONTH_LINK }}</a
                          >
                          <a
                            href="#"
                            id="customDateLink"
                            @click.prevent="
                              showCustomPicker = true;
                              showCustomDate = true;
                            "
                            >{{ constants.CUSTOM_DATE_LINK }}</a
                          >
                        </div>
                        <div class="custom-date-picker">
                          <Datepicker
                            v-if="showCustomPicker"
                            range
                            :enable-time-picker="false"
                            :clearable="false"
                            menu-class-name="custom-datepicker-menu"
                            :inline="true"
                            @range-start="onRangeStart"
                            @range-end="onRangeEnd"
                          >
                            <template #action-buttons>
                              <div class="action-buttons">
                                <button
                                  id="cancelButton"
                                  class="cancel-btn"
                                  @click="resetClasses"
                                >
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                                <button
                                  id="doneButton"
                                  class="apply-btn"
                                  @click="handleDate()"
                                >
                                  {{ constants.DONE_BUTTON }}
                                </button>
                              </div>
                            </template>
                          </Datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="criteria-button">
                      <button class="btn_link"  data-bs-toggle="modal" data-bs-target="#criteriaPop" id="criteriaBtn" @click="openCriteriaModal">
                        {{ constants.CRITERIA_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="selected-tags-section">
                <div class="admin-right-sidebar-in-top-right-btm select-all-positions">
                    <div class="select-all-checkbox">
                      <div class="admin-checkbox-input">
                        <input
                          name="cssCheckbox"
                          id="item_1"
                          type="checkbox"
                          class="css-checkbox"
                          v-model="selectAllCandidates"
                          @change="toggleSelectAllCandidates"
                        />
                        <label for="item_1">Select All</label>
                      </div>
                    </div> 
                    <div class="tags">
                      <ul>
                        <li v-if="selectedJoinTeams.length > 0">
                          <span
                            >{{ selectedJoinTeams.length }} entries
                            selected</span
                          >
                          <button
                            id="tagCloseBtn"
                            @click="selectedJoinTeams = []; selectAll = false; selectAllCandidates = false;"
                          ></button>
                        </li>
                        <li v-if="dateFilter === 'custom'">
                          <span
                            >{{ formatCustomDate(startDate) }}-{{
                              formatCustomDate(endDate)
                            }}</span
                          >
                          <button
                            id="tagCloseBtn"
                            @click="clearDateFilter"
                          ></button>
                        </li>
                        <li v-if="dateFilter === 'lastWeek'">
                          <span>Last Week </span>
                          <button
                            id="tagCloseBtn"
                            @click="
                              (dateFilter = ''),
                                fetchJoinTeams(activeTab),
                                fetchCounts(),
                                (limit =20)
                            "
                          ></button>
                        </li>
                        <li v-if="dateFilter === 'lastMonth'">
                          <span>Last Month</span>
                          <button
                            id="tagCloseBtn"
                            @click="
                              (dateFilter = ''),
                                fetchJoinTeams(activeTab),
                                fetchCounts(),
                                (limit = 20)
                            "
                          ></button>
                        </li>
                        <li
                          class="tags-status"
                          v-if="selectedJoinTeams.length > 1 && hasSameStatus()"
                        >
                          <select
                            class="tags-status-selectbox"
                            @change="handleBulkStatusChange"
                            v-model="bulkStatusValue"
                          >
                            <option value="" disabled>Select Status</option>
                            <option value="0">Pending</option>
                            <option value="1">Hired</option>
                            <option value="2">Rejected</option>
                          </select>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="delete-all-btn-link"
                      v-if="selectedJoinTeams.length > 1"
                    >
                      <button
                        class="btn_link"
                        id="deleteAllBtn"
                        data-bs-toggle="modal"
                        data-bs-target="#deletePop"
                        @click="setDeleteMode('all')"
                      >
                        Delete
                      </button>
                    </div>
                    <div
                      class="delete-all-btn-link"
                      v-if="selectedJoinTeams.length > 1"
                    >
                      <button
                        class="btn_link"
                        id="downloadAllBtn"
                        @click="downloadResume('all')"
                      >
                        {{ constants.DOWNLOAD_ALL_BUTTON }}
                      </button>
                    </div>
                    <div class="re-calculator-ai-btn" v-if="selectedJoinTeams.length > 0">
											<button data-bs-toggle="modal" data-bs-target="#reproductAiScorePopup" id="criteriaBtn" class="btn_link" @click="openReproduceModal">Reproduce AI Score</button>
										</div>            
                    <div class="export-dropdown" :class="{ 'show-dropdown': isExportDropdownOpened}">
                      <button id="exportBtn" class="export-dropdown-btn" @click="toggleExportDropdown">
                        {{ constants.EXPORT_BUTTON }}
                      </button>
                      <div class="export-dropdown-list">
                        <ul>
                          <li>
                            <button
                              id="downloadBtn"
                              class="admin-btn-outline-primary li_file_download_btn"
                              @click="exportToExcel"
                            >
                              {{ constants.DOWNLOAD_BUTTON }}
                            </button>
                          </li>

                           <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_1"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="selectAllExportFields"
                                @change="toggleSelectAllExportFields"
                              />
                              <label for="export_item_1">
                                {{ constants.ALL_LINK }}
                              </label>
                            </div>
                          </li>

                          <!-- <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_1"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.image"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_1">
                                {{ constants.IMAGE_LABEL }}
                              </label>
                            </div>
                          </li> -->
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_2"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.name"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_2">
                                {{ constants.NAME_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_3"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.email"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_3">
                                {{ constants.EMAIL_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_4"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.designation"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_4">
                                {{ constants.DESIGNATION_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_5"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.reference"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_5">
                                {{ constants.NAME_OF_REFERENCE_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_6"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.description"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_6">
                                {{ constants.DESCRIPTION_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_7"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.status"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_7">
                                {{ constants.STATUS_LABEL }}
                              </label>
                            </div>
                          </li>
                          <li>
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                id="export_item_8"
                                type="checkbox"
                                class="css-checkbox"
                                v-model="exportFields.date"
                                @change="updateSelectAllExportFields"
                              />
                              <label for="export_item_8">
                                {{ constants.DATE_LABEL }}
                              </label>
                            </div>
                          </li>

                          <li>
                            <div class="export-dropdown-btns">
                              <button class="admin-btn-outline-primary">
                                Done
                              </button>
                              <button @click="exportFields = {
                                image: false,
                                name: false,
                                email: false,
                                designation: false,
                                reference: false,
                                description: false,
                                status: false,
                                date: false,
                              };selectAllExportFields = false;" class="admin-btn-outline-secondary">
                                Cancel
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div
              :class="[
                'admin-item-list-section admin-join-team-section',
                { 'show-edit-item-outer': editFormSubmitted },
              ]"
              v-if="editJoinTeamsData.length > 0"
            >
              <div
                class="admin-item-list-section-in"
                ref="scrollWrapper"
                data-simplebar
              >
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input
                            name="cssCheckbox"
                            id="selectAll"
                            type="checkbox"
                            class="css-checkbox"
                            @change="toggleSelectAll"
                            v-model="selectAll"
                          />
                          <label for="selectAll"></label>
                        </div>
                      </div>
                      <div class="admin-item-image">
                        {{ constants.IMAGE_LABEL }}
                      </div>
                      <div class="admin-item-team-name" @click="toggleSort('candidateName')" style="cursor: pointer;">
                        {{ constants.NAME_LABEL }}
                        <button v-if="sortBy === 'candidateName' || sortBy === '-candidateName'" class="sorting-btn" :class="{ 'sorted': sortBy === '-candidateName' }"></button>
                      </div>
                      <div class="admin-item-team-email" @click="toggleSort('email')" style="cursor: pointer;">
                        {{ constants.EMAIL_LABEL }}
                        <button v-if="sortBy === 'email' || sortBy === '-email'" class="sorting-btn" :class="{ 'sorted': sortBy === '-email' }"></button>
                      </div>
                      <div class="admin-item-join-team-designation" @click="toggleSort('designation')" style="cursor: pointer;">
                        {{ constants.DESIGNATION_LABEL }}
                        <button v-if="sortBy === 'designation' || sortBy === '-designation'" class="sorting-btn" :class="{ 'sorted': sortBy === '-designation' }"></button>
                      </div>
                      <!-- <div class="admin-item-team-reference" @click="toggleSort('nameOfReference')" style="cursor: pointer;">
                        {{ constants.NAME_OF_REFERENCE_LABEL }}
                        <button v-if="sortBy === 'nameOfReference' || sortBy === '-nameOfReference'" class="sorting-btn" :class="{ 'sorted': sortBy === '-nameOfReference' }"></button>
                      </div>
                      <div class="admin-item-team-join-description" @click="toggleSort('description')" style="cursor: pointer;">
                        {{ constants.DESCRIPTION_LABEL }}
                        <button v-if="sortBy === 'description' || sortBy === '-description'" class="sorting-btn" :class="{ 'sorted': sortBy === '-description' }"></button>
                      </div> -->
                      <!-- <div class="admin-item-team-status">
                        {{ constants.STATUS_LABEL }}
                      </div> -->
                      <div class="admin-item-team-date" @click="toggleSort('Created_at')" style="cursor: pointer">
                        {{ constants.DATE_LABEL }}
                        <button
                          v-if="
                            sortBy === 'Created_at' ||
                            sortBy === '-Created_at'
                          "
                          class="sorting-btn"
                          :class="{ sorted: sortBy === '-Created_at' }"
                        ></button>
                      </div>
                      <div class="admin-item-ai-score" @click="toggleSort('ai_score')" style="cursor: pointer;">
                        {{ constants.AI_SCORE_LABEL }}
                        <button v-if="sortBy === 'ai_score' || sortBy === '-ai_score'" class="sorting-btn" :class="{ 'sorted': sortBy === '-ai_score' }"></button>
											</div>
                      <div class="admin-item-last-processed" @click="toggleSort('Updated_at')" style="cursor: pointer;">
                        {{ constants.LAST_PROCESSED_AT_LABEL }}
                        <button v-if="sortBy === 'Updated_at' || sortBy === '-Updated_at'" class="sorting-btn" :class="{ 'sorted': sortBy === '-Updated_at' }"></button>
											</div>
                      <div class="admin-item-criteri-version" @click="toggleSort('criteria_version')" style="cursor: pointer;">
                        {{ constants.CRITERIA_VERSION_LABEL }}
                        <button v-if="sortBy === 'criteria_version' || sortBy === '-criteria_version'" class="sorting-btn" :class="{ 'sorted': sortBy === '-criteria_version' }"></button>
											</div>
                      <div class="join-team-actions">
                        {{ constants.ACTIONS_LABEL }}
                      </div>
                    </div>
                  </div>
                  <div class="admin-item-list-btm">
                    <div
                      v-for="(joinTeam, index) in editJoinTeamsData"
                      :key="joinTeam.id"
                      :class="[
                        'admin-item-box',
                        { 'show-edit-item': joinTeam.editing },
                      ]"
                    >
                      <div class="admin-item-box-top">
                        <div class="admin-item-list-row">
                          <div v-if="joinTeam.status === 0 && !joinTeam.is_viewed" class="new-message-point"></div>
                          <div class="admin-item-checkbox">
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                :id="'demo_opt_' + joinTeam.id"
                                type="checkbox"
                                class="css-checkbox"
                                @change="toggleJoinTeamSelection(joinTeam.id)"
                                :checked="
                                  selectedJoinTeams.includes(joinTeam.id)
                                "
                              />
                              <label :for="'demo_opt_' + joinTeam.id"></label>
                            </div>
                          </div>
                          <div class="admin-item-image">
                            <div class="sm-img">
                              <img
                                :src="
                                  getCdnImageAddress(
                                    joinTeam.candidateImage,
                                    `w_40,h_41/`
                                  )
                                "
                                alt=""
                              />
                            </div>
                          </div>
                          <div class="admin-item-team-name">
                            <div class="limited-text text-limit">
                              {{ joinTeam.candidateName }}
                            </div>
                          </div>
                          <div class="admin-item-team-email">
                            {{ joinTeam.email }}
                          </div>
                          <div
                            class="admin-item-join-team-designation text-limit"
                          >
                            {{ joinTeam.designation }}
                          </div>
                          <!-- <div class="admin-item-team-reference">
                            {{ joinTeam.nameOfReference }}
                          </div>
                          <div
                            class="admin-item-team-join-description text-limit"
                          >
                            {{ joinTeam.description }}
                          </div> -->
                          <div class="admin-item-team-date">
                            <span
                              v-b-tooltip.up="{
                                title: formatDate(joinTeam.Created_at),
                              }"
                              v-if="joinTeam.Created_at"
                            >
                              {{ getRelativeTime(joinTeam.Created_at) }}
                            </span>
                          </div>
                          <div class="admin-item-ai-score">
                            <button class="ai-score-popup-btn" data-bs-toggle="modal" data-bs-target="#aiScorePop" @click="openAiScorePopup(joinTeam)">
                              {{ getAiScore(joinTeam) }}% <i class="ai-score-popup-icon"></i>
                              <span v-if="candidatesBeingProcessed.includes(joinTeam.id)" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            </button>
                          </div>
                          <div class="admin-item-last-processed">
                            <span
                              v-b-tooltip.up="{
                                title: formatDate(joinTeam.Updated_at),
                              }"
                              v-if="joinTeam.Updated_at"
                              >
                              {{ formatDate(joinTeam.Updated_at) }}
                            </span>
                          </div>
                          <div class="admin-item-criteri-version">
                            <span>
                              v{{ joinTeam.criteria_version }}
                            </span>
                          </div>
                          <div class="join-team-actions">
                            <ul class="admin-action-link">
                              <li>
                                <button
                                  id="teamPgPublishBtn"
                                  class="viewbtn"
                                  @click="
                                    dummyfunction(
                                      index,
                                      joinTeam.id,
                                      joinTeam.email
                                    )
                                  "
                                >
                                  {{ constants.VIEW_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <button
                                  id="joinTeamPgDwonloadBtn"
                                  @click="
                                    downloadResume(
                                      'single',
                                      joinTeam.id,
                                      joinTeam.candidateName
                                    )
                                  "
                                >
                                  {{ constants.DOWNLOAD_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <button
                                  class="hide-row-btn"
                                  id="joinTeamPgDeleteBtn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deletePop"
                                  @click="
                                    setDeleteMode('single', joinTeam.id)
                                  "
                                >
                                  {{ constants.DELETE_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <div class="status-select-box">
                                  <select
                                    :id="'statusSelectBox_' + joinTeam.id"
                                    class="statusselectbox"
                                    @change="onStatusChange($event, joinTeam.id)"
                                    :style="getStatusColor(joinTeam.status)"
                                    @click="personId(joinTeam.id)"
                                  >
                                    <option
                                      value="pending"
                                      :selected="joinTeam.status === 0"
                                    >
                                      Pending
                                    </option>
                                    <option
                                      value="hired"
                                      :selected="joinTeam.status === 1"
                                    >
                                      Hired
                                    </option>
                                    <option
                                      value="rejected"
                                      :selected="joinTeam.status === 2"
                                    >
                                      Rejected
                                    </option>
                                  </select>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        class="admin-item-box-btm join-team-details"
                        v-if="joinTeam.editing"
                      >
                        <div class="join-team-details-box">
                          <button class="viewclose" id="viewCloseBtn" @click="editFormSubmitted = false">
                            <img src="@/assets/images/admin-img/tags-close-icon.svg" alt="" />
                          </button>
                          <div class="join-team-tabs-details">
                            <div class="join-team-tabs-details-left">
                              <div class="sender-img">
                                <img
                                  :src="
                                    editimageSrc ||
                                    require('@/assets/images/admin-img/image-icon.svg')
                                  "
                                  alt=""
                                />
                              </div>
                            </div>
                            <div class="join-team-tabs-details-right">
                              <div class="sender-info">
                                <ul>
                                  <li>
                                    <label>{{ constants.NAME_LABEL }}:</label>
                                    <span class="span-txt">{{ joinTeam.candidateName }}</span>
                                  </li>
                                  <li>
                                    <label>{{ constants.DESIGNATION_LABEL }}:</label>
                                    <span class="span-txt">{{ joinTeam.designation }}</span>
                                  </li>
                                  <li>
                                    <label>{{ constants.DATE_LABEL }}:</label>
                                    <span class="span-txt">{{ formatDate(joinTeam.Created_at) }}</span>
                                  </li>
                                  <li>
                                    <label>{{ constants.EMAIL_LABEL }}:</label>
                                    <span class="span-txt">{{ joinTeam.email }}</span>
                                  </li>
                                  <li>
                                    <label>{{ constants.NAME_OF_REFERENCE_LABEL }}:</label>
                                    <span class="span-txt">{{ joinTeam.nameOfReference }}</span>
                                  </li>
                                  <li class="li-item-50">
                                    <div class="label-item-box">
                                      <label>{{ constants.STATUS_LABEL }}:</label>
                                      <span class="span-txt">
                                        <div class="status-in-view status-new">New</div>
                                      </span>
                                    </div>
                                    <div class="label-item-box">
                                      <label>{{ constants.AI_SCORE_LABEL }}:</label>
                                      <span class="span-txt">
                                        <button class="ai-score-popup-btn" data-bs-toggle="modal" data-bs-target="#aiScorePop" @click="openAiScorePopup(joinTeam)">{{ getAiScore(joinTeam) }}% <i class="ai-score-popup-icon"></i></button>
                                      </span>
                                    </div>
                                  </li>
                                  <li class="full-desc">
                                    <label>{{ constants.DESCRIPTION_LABEL }}:</label>
                                    <span class="span-txt">{{ joinTeam.description }}</span>
                                  </li>
                                  <li>
                                    <label>{{ constants.ATTACHMENT_LABEL }}:</label>
                                    <span>
                                      <div class="attachment-box">
                                        <i>
                                          <img src="@/assets/images/admin-img/pdf-icon.svg" alt="" />
                                        </i>
                                        <div class="attachment-info">
                                          <span>{{ joinTeam.resumeName }}</span>
                                          <span>{{ joinTeam.resumeSize }}</span>
                                        </div>
                                        <button
                                          class="attachmentDownloadBtn"
                                          @click="downloadResume('single', joinTeam.id)"
                                        >
                                          <img
                                            src="@/assets/images/admin-img/download-icon.svg"
                                            alt=""
                                          />
                                        </button>
                                      </div>
                                    </span>
                                  </li>
                                </ul>
                              </div>
                              <div class="sender-actions">
                              </div>
                            </div>
                          </div>
                          <div class="conversation-history-count-section">
                            <h6>{{ constants.CONVERSATION_HISTORY_TEXT }} : {{ emailThread.length }}</h6>
                            <ul class="mail-ul-actions">
                              <li>
                                <button
                                  id="replyMailBtn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#replyPop"
                                  @click="(candidateId = joinTeam.id), (errMsg = '')"
                                >
                                  {{ constants.NEW_EMAIL_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <button
                                  id="deleteMailBtn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deletePop"
                                  @click="setDeleteMode('single', joinTeam.id)"
                                >
                                  {{ constants.DELETE_BUTTON }}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div class="join-team-tabs">
                            <div class="join-team-tabs-items-row join-team-tabs-hd">
                              <div class="join-team-items join-team-items-date">
                                {{ constants.DATE_LABEL }}
                              </div>
                              <div class="join-team-items join-team-items-from">
                                {{ constants.FROM_LABEL }}
                              </div>
                              <div class="join-team-items join-team-items-to">
                                {{ constants.TO_LABEL }}
                              </div>
                              <div class="join-team-items join-team-items-sub">
                                {{ constants.SUBJECT_LABEL }}
                              </div>
                              <div class="join-team-items join-team-items-actions">
                                {{ constants.ACTION_LABEL }}
                              </div>
                            </div>
                            <div class="join-team-tabs-content">
                              <div
                                class="join-team-tabs-box"
                                v-for="(thread, index) in emailThread"
                                :key="index"
                                :class="{ 'tabs-open': thread.isOpen }"
                              >
                                <button
                                  class="collapse-btn"
                                  @click="toggleCollapse(index)"
                                ></button>
                                <div class="join-team-tabs-box-top">
                                  <div class="join-team-tabs-items-row">
                                    <div class="join-team-items join-team-items-date">
                                      <span
                                        v-b-tooltip.up="{
                                          title: formatDate(thread.Created_at),
                                        }"
                                      >
                                        {{ formatDate(thread.Created_at) }}
                                      </span>
                                    </div>
                                    <div class="join-team-items join-team-items-from">
                                      {{ thread.email }}
                                    </div>
                                    <div class="join-team-items join-team-items-to">
                                      {{ thread.to || 'hr@lmdconsulting.com' }}
                                    </div>
                                    <div class="join-team-items join-team-items-sub">
                                      {{ thread.subject }}
                                    </div>
                                    <div class="join-team-items join-team-items-actions">
                                      <ul class="admin-action-link">
                                        <li>
                                          <button id="deleteMailBtn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deletePop" @click="setDeleteMode('emailThread', undefined, thread.id)">
                                            {{ constants.DELETE_BUTTON }}
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="join-team-tabs-box-btm">
                                  <div class="join-team-email-content">
                                    <ul>
                                      <li>
                                        <div class="join-team-email-item">
                                          <label>{{ constants.FROM_LABEL }}:</label>
                                          <span>{{ thread.email }}</span>
                                        </div>
                                        <div class="join-team-email-date">
                                          {{ formatDate(thread.Created_at) }}
                                        </div>
                                      </li>
                                      <li>
                                        <div class="join-team-email-item">
                                          <label>{{ constants.SUBJECT_LABEL }}:</label>
                                          <span>{{ thread.subject }}</span>
                                        </div>
                                      </li>
                                      <li>
                                        <div class="join-team-email-item">
                                          <label>{{ constants.TO_LABEL }}:</label>
                                          <span>{{ thread.to || 'hr@lmdconsulting.com' }}</span>
                                        </div>
                                      </li>
                                      <li>
                                        <div class="join-team-email-full-message">
                                          <p v-html="thread.emailContent"></p>
                                        </div>
                                      </li>
                                      <li>
                                        <ul class="mail-ul-actions">
                                          <li>
                                            <button id="replyMailBtn" data-bs-toggle="modal" data-bs-target="#replyPop" @click="(candidateId = joinTeam.id), (errMsg = '')">
                                              {{ constants.REPLY_BUTTON }}
                                            </button>
                                          </li>
                                          <li>
                                            <button id="deleteMailBtn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#deletePop" @click="setDeleteMode('emailThread', undefined, thread.id)">
                                              {{ constants.DELETE_BUTTON }}
                                            </button>
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select
                      id="paginationSelectBox"
                      v-model="limit"
                      @change="handleLimitChange"
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span> {{ constants.ENTRIES_PER_PAGE_LABEL }} </span>
                  </div>
                  <div
                    class="admin-pagination"
                    id="paginationBox"
                    v-if="totalPages > 1"
                  >
                    <ul>
                      <li
                        v-if="currentPage !== 1"
                        @click="changePage(currentPage - 1)"
                      >
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li
                        v-for="page in visiblePages"
                        :key="page"
                        @click="changePage(page)"
                        v-if="totalPages != 1"
                      >
                        <a href="#" :class="{ active: currentPage === page }">{{
                          page
                        }}</a>
                      </li>
                      <li
                        v-if="currentPage !== totalPages"
                        @click="changePage(currentPage + 1)"
                      >
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No data to display</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
    <!-------------------------- Delete Pop Start --------------------------------->
    <div
      class="modal fade confirmation-popup"
      id="deletePop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i
              ><img
                src="@/assets/images/admin-img/light_delete-outline.svg"
                alt=""
            /></i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmDelete"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- Delete Pop End --------------------------------->

    <!-------------------------- pendingPopup Pop Start --------------------------------->
    <div
      class="modal fade confirmation-popup"
      id="followupPop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="followupModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content followupPop">
          <div class="confirmation-popup-icon">
            <i
              ><img src="@/assets/images/admin-img/light_w-outline.svg" alt=""
            /></i>
          </div>
          <div class="confirmation-popup-mid">
            Are you sure, you want to change the status to pending?
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
              @click="resetStatus"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmStatusChange()"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- pendingPopup Pop End --------------------------------->

    <!-------------------------- HiredPop Pop Start --------------------------------->
    <div
      class="modal fade confirmation-popup"
      id="HiredPop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="HiredModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content HiredPop">
          <div class="confirmation-popup-icon">
            <i><img src="@/assets/images/admin-img/hired.svg" alt="" /></i>
          </div>
          <div class="confirmation-popup-mid">
            Are you sure, you want to hire this?
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
              @click="resetStatus"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmStatusChange()"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- HiredPop Pop End --------------------------------->

    <!-------------------------- rejectedPop Pop Start --------------------------------->
    <div
      class="modal fade confirmation-popup"
      id="rejectedPop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="rejectedModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content rejectedPop">
          <div class="confirmation-popup-icon">
            <i><img src="@/assets/images/admin-img/reject.svg" alt="" /></i>
          </div>
          <div class="confirmation-popup-mid">
            Are you sure, you want to rejected this?
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
              @click="resetStatus"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmStatusChange()"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- rejectedPop Pop End --------------------------------->

    <!-------------------------- Reply Pop Start --------------------------------->
    <div
      class="modal fade reply-popup"
      id="replyPop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="replyModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button
            class="reply-pop-close"
            data-bs-dismiss="modal"
            id="replyPopCloseBtn"
          >
            <img src="@/assets/images/admin-img/tags-close-icon.svg" alt="" />
          </button>
          <h2>Reply to {{ editJoinTeamData.candidateName }}</h2>
          <div class="reply-form">
            <form id="emailReplyForm" @submit.prevent="submitForm">
              <div class="admin-input-field">
                <label>
                  {{ constants.NAME_LABEL }}
                </label>
                <input
                  id="replyNameInput"
                  type="text"
                  placeholder="Enter the Name"
                  v-model="editJoinTeamData.candidateName"
                />
              </div>
              <div class="admin-input-field">
                <label>
                  {{ constants.EMAIL_LABEL }}
                </label>
                <input
                  id="replyNameInput"
                  type="text"
                  placeholder="Enter the Email"
                  v-model="editJoinTeamData.email"
                />
              </div>
              <div class="admin-input-field">
                <label>
                  {{ constants.SUBJECT_LABEL }}
                </label>
                <input
                  id="replyNameInput"
                  type="text"
                  placeholder="Enter the Subject"
                  v-model="newEmail.subject"
                />
                <div class="error-msg" v-if="!newEmail.subject">
                  {{ errMsg }}
                </div>
              </div>
              <div class="admin-input-field">
                <label>
                  {{ constants.DESCRIPTION_LABEL }}
                </label>
                <!-- <div class="text-editer" id="replyDescInput"> -->
                <ckeditor
                  placeholder="Description"
                  class="text-editer"
                  id="replyDescInput"
                  :editor="editor"
                  v-model="newEmail.description"
                  :config="editorConfig"
                ></ckeditor>
                <!-- </div> -->
                <div class="error-msg" v-if="!newEmail.description">
                  {{ errMsg }}
                </div>
              </div>
              <div class="admin-input-field-submit">
                <button
                  id="servicesPgSubmitBtn"
                  type="submit"
                  class="admin-btn-outline-primary"
                  :disabled="isSubmitting"
                >
                  {{ constants.SUBMIT_BUTTON }}
                </button>
                <button
                  type="button"
                  class="dummy-btn"
                  data-bs-dismiss="modal"
                  ref="dummyButton"
                  style="display: none"
                ></button>
                <button
                  id="servicesPgSubmitBtn"
                  type="button"
                  class="admin-btn-outline-secondary"
                  data-bs-dismiss="modal"
                  @click.prevent="resetForm"
                >
                  {{ constants.CANCEL_BUTTON }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- Reply Pop End --------------------------------->

    <!-------------------------- AI Score Pop Start --------------------------------->
		<div class="modal fade ai-score-popup" id="aiScorePop" tabindex="-1" role="dialog" aria-labelledby="replyModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button class="ai-score-pop-close" data-bs-dismiss="modal" id="replyPopCloseBtn"><img src="@/assets/images/admin-img/tags-close-icon.svg" alt="" /></button>
          <div class="ai-score-popup-top">
            <div class="ai-score-popup-top-left">
              <div class="person-ai-score-info">
                <div class="person-ai-score-img">
                  <img 
                    :src="selectedCandidate?.candidateImage ? getCdnImageAddress(selectedCandidate.candidateImage, 'w_80,h_80/') : require('@/assets/images/admin-img/image-icon.svg')" 
                    alt="" 
                  />
                </div>
                <div class="person-ai-score-content">
                  <div class="person-ai-score-content-name">
                    <h3>{{ selectedCandidate?.candidateName}}</h3>
                    <div class="status-in-view" :style="getStatusColor(selectedCandidate?.status)">{{ getStatusText(selectedCandidate?.status) }}</div>
                  </div>
                  <div class="person-ai-score-content-job">
                    <span>
                      {{ constants.APPLIED_FOR_JOB_TEXT }}
                    </span>
                    <h5>{{ selectedCandidate?.designation}}</h5>
                  </div>
                  <div class="person-ai-score-content-location">
                    <span>
                      {{ constants.APPLICATION_SUBMITTED_TEXT }}
                    </span>
                    <h5>{{ formatDate(selectedCandidate?.Created_at) }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="ai-score-popup-top-right">
              <div class="ai-score-status-box" :class="`ai-score-status-box-${currentScoreColor}`">
                <div class="ai-score-status-chart">
                  <svg viewBox="0 0 36 36" :class="`circular-chart circular-chart-${currentScoreColor}`">
                    <path
                      class="circle-bg"
                      d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path
                      class="circle"
                      :stroke-dasharray="`${currentScore}, 100`"
                      d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <text x="18" y="20.35" class="percentage">{{ currentScore }}%</text>
                  </svg>
                </div>
                <div class="ai-score-status-content">
                  <h5>Job Match Score</h5>
                  <p>{{ currentScoreText }}</p>
                  <p>Processed using version {{ getLatestEvaluation(selectedCandidate)?.criteria_version }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-score-popup-bottom">
            <div class="ai-score-popup-tabs-section">
              <div class="ai-score-popup-tabs-top">
                <ul class="nav" id="myTab" role="tablist">
                  <li role="presentation">
                    <button class="active" id="score-override-tab" data-bs-toggle="tab" data-bs-target="#scoreOverride" type="button" role="tab" aria-controls="scoreOverride" aria-selected="true">
                      {{ constants.SCORE_OVERRIDE_BUTTON }}
                    </button>
                  </li>
                  <li role="presentation">
                    <button class="" id="score-history-tab" data-bs-toggle="tab" data-bs-target="#scoreHistory" type="button" role="tab" aria-controls="scoreHistory" aria-selected="false">
                      {{ constants.OVERRIDE_HISTORY_BUTTON }}
                    </button>
                  </li>
                  <li role="presentation">
                    <button class="" id="score-resume-tab" data-bs-toggle="tab" data-bs-target="#scoreResume" type="button" role="tab" aria-controls="scoreResume" aria-selected="false">
                      {{ constants.RESUME_BUTTON }}
                    </button>
                  </li>
                  <li role="presentation">
                    <button class="" id="score-criteria-tab" data-bs-toggle="tab" data-bs-target="#scoreCriteria" type="button" role="tab" aria-controls="scoreCriteria" aria-selected="false">
                      {{ constants.CRITERIA_TEXT }}
                    </button>
                  </li>
                  <li role="presentation">
                    <button class="" id="score-ai-log-tab" data-bs-toggle="tab" data-bs-target="#scoreAiLog" type="button" role="tab" aria-controls="scoreAiLog" aria-selected="false">
                      AI Logs
                    </button>
                  </li>
                </ul>
              </div>
              <div class="ai-score-popup-tabs-btm">
                <div class="tab-content" id="myTabContent" >                 
                  <div class="tab-pane fade show active" id="scoreOverride" role="tabpanel" aria-labelledby="score-override-tab">
                    <div class="score-override-tab-details" >
                      
                        <div class="score-override-tab-details-step-1" :style="{ display: showStep1 ? 'block' : 'none' }">
                          <div class="score-override-tab-details-step-1-left">
                            <div class="score-summary-desc">
                              <p>
                                {{ displayScoreSummary }}
                              </p>
                              <button 
                                v-if="shouldShowReadMore" 
                                class="read-more-link"
                                @click="toggleScoreSummary"
                              >
                                {{ isScoreSummaryExpanded ? constants.SHOW_LESS_LINK : constants.READ_MORE_LINK }}
                              </button>
                            </div>
                          </div>
                          <div class="score-override-tab-details-step-1-right">
                            <div class="score-summary-items-slider">
                              <Carousel :itemsToShow="4" :wrapAround="false" :transition="300" :snapAlign="'start'">
                                <Slide v-for="reviewer in availableReviewers" :key="reviewer"  :class="{ active: activeReviewer === reviewer }">
                                  <button @click="switchReviewer(reviewer)">{{ reviewer }}</button>
                                </Slide>
                                <template #addons>
                                  <Navigation />
                                </template>
                              </Carousel>
                            </div>
                            <div class="scores-edit-section" :style="{ display: isOverallScoreExpanded ? 'none' : 'block' }" >
                              <div ref="scrollWrapper" class="ai-pop-scroll-sm-outr" data-simplebar>
                              <div class="ai-pop-scroll-sm"> 
                                <div class="scores-edit-box" v-for="[key, breakdown] in currentScoreBreakdown" :key="`${activeReviewer}-${key}`">
                                  <div class="scores-edit-box-left">
                                    <div class="scores-edit-box-left-top">
                                      <div class="scores-edit-name">{{ getBreakdownLabel(key) }}</div>
                                      <div class="scores-edit-percentage">{{ breakdown.score }}%</div>
                                    </div>
                                    <div class="scores-edit-progress-bar" :style="`background-color: ${getScoreColor(breakdown.score).background};`">
                                      <span class="scores-edit-progress-done" :style="`width: ${breakdown.score}%; background-color: ${getScoreColor(breakdown.score).progress};`"></span>
                                    </div>
                                  </div>
                                  <div class="scores-edit-box-right">
                                    <ul class="scores-edit-icon-list">
                                      <li><button class="scores-edit-icon" @click="editSingleScore(key)"></button></li>
                                    </ul>
                                  </div>
                                  <div class="scores-edit-box-weight">
                                    <ul>
                                      <li><strong>{{ getWeightedScore(key) }}</strong>AI Weight</li>
                                      <li><strong>{{ getOriginalWeight(key) }}</strong>Original Weight</li>
                                    </ul>
                                  </div>
                                </div>
                               
                              </div> 
                               </div> 
                                <div class="edit-all-scores-btn" v-if="!isOverallScoreExpanded" @click="editAllScores">
                              <button>
                                {{ constants.EDIT_ALL_SCORES_BUTTON }}
                              </button>
                            </div> 
                            </div>
                            <div class="over-all-score-chart" :style="{ display: isOverallScoreExpanded ? 'block' : 'none' }">
                                    <canvas ref="overallScoreChart" width="400" height="300"></canvas>
                            </div>
                            
                          </div>
                        </div>
                        <div class="score-override-tab-details-step-2" :style="{ display: showStep1 ? 'none' : 'block' }" >
                         
 
                              <div class="score-interviewer-name">
                                <label>
                                  {{ constants.INTERVIEWER_NAME_LABEL }}
                                </label>
                                <input type="text" placeholder="Enter the Interviewer Name" v-model="editedScore.reviewer_name" />
                                <div v-if="reviewerNameError" class="error-msg">
                                  {{ reviewerNameError }}
                                </div>
                              </div>
 <div ref="scrollWrapper" class="ai-pop-scroll-sm-edit-outr" data-simplebar>
                              <div class="ai-pop-scroll-sm-edit">
                                <div class="score-override-edit-reason-section">
                                  <div class="score-override-edit-single-reason" :style="{ display: editScoreType === 'single' ? 'block' : 'none' }">
                                    <div class="score-override-edit-reason">
                                      <div class="score-override-edit-reason-top">
                                        <div class="score-override-edit-reason-left">
                                          <div class="score-override-edit-reason-left-top">
                                            <h4>{{ selectedReasonKey ? getBreakdownLabel(selectedReasonKey) : '' }}</h4>
                                            <span class="current-score">{{ getEditedScore(selectedReasonKey) }}%</span>
                                          </div>
                                          <div class="score-override-edit-reason-left-btm" :style="`background-color: ${getScoreColor(getEditedScore(selectedReasonKey)).background};`">
                                            <span
                                              :style="`width: ${getEditedScore(selectedReasonKey)}%; background-color: ${getScoreColor(getEditedScore(selectedReasonKey)).progress};`"
                                              class="progress-bar-done"
                                            ></span>
                                          </div>
                                        </div>
                                        <div class="score--edit-input">
                                          <input type="number" id="newScoreinput" min="0" max="100" step="1" name="score" placeholder="Enter Score(0-100)" :value="getEditedScore(selectedReasonKey)" @input="updateEditedScore(selectedReasonKey, $event)" />
                                          <div v-if="scoreErrors[selectedReasonKey]" class="error-mesg">
                                            {{ scoreErrors[selectedReasonKey] }}
                                          </div>
                                        </div>
                                      </div>
                                      <div class="feedback-summary-textarea">
                                        <label>
                                          {{ constants.FEEDBACK_SUMMARY_LABEL }}
                                        </label>
                                        <div class="feedback-summary-textedit">
                                          <textarea :value="getEditedFeedback(selectedReasonKey)" @input="updateEditedFeedback(selectedReasonKey, $event)" placeholder="Enter feedback" rows="3"></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="score-override-edit-multi-reason" :style="{ display: editScoreType === 'multiple' ? 'block' : 'none' }">
                                    <div class="accordion" id="accordionExample">
                                      <div class="accordion-item" v-for="[key, breakdown] in sortedScoreBreakdown" :key="key">
                                        <h2 class="accordion-header" :id="'heading-' + key">
                                          <button  class="accordion-button" 
                                            :class="{ collapsed: !expandedItems[key] }"
                                            type="button" 
                                            @click="toggleAccordion(key)"
                                            :aria-expanded="expandedItems[key]"
                                            :aria-controls="'collapse-' + key">
                                            {{ getBreakdownLabel(key) }}
                                          </button>
                                        </h2>
                                        <div :id="'collapse-' + key" 
                                          class="accordion-collapse" 
                                          :class="{ collapse: !expandedItems[key], show: expandedItems[key] }"
                                          :aria-labelledby="'heading-' + key" 
                                          data-bs-parent="#accordionExample">
                                          <div class="accordion-body">
                                            <div class="score-override-edit-reason">
                                              <div class="score-override-edit-reason-top">
                                                <div class="score-override-edit-reason-left">
                                                  <div class="score-override-edit-reason-left-top">
                                                    <h4>{{ getBreakdownLabel(key) }}</h4>
                                                    <span class="current-score">{{ scoreUpdates[key] }}%</span>
                                                  </div>
                                                  <div class="score-override-edit-reason-left-btm" :style="`background-color: ${getScoreColor(parseInt(scoreUpdates[key]) || 0).background};`">
                                                    <span :style="`width: ${scoreUpdates[key]}%; background-color: ${getScoreColor(parseInt(scoreUpdates[key]) || 0).progress};`" class="progress-bar-done"></span>
                                                  </div>
                                                </div>
                                                <div class="score--edit-input">
                                                  <input type="number" :id="'newScoreinput-' + key" name="score" min="0" max="100" step="1" placeholder="Enter Score" :value="scoreUpdates[key]" @input="updateScoreInput(key, $event)" />
                                                  <div v-if="scoreErrors[key]" class="error-mesg">
                                                    {{ scoreErrors[key] }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="feedback-summary-textarea">
                                                <label>
                                                  {{ constants.FEEDBACK_SUMMARY_LABEL }}
                                                </label>
                                                <div class="feedback-summary-textedit">
                                                  <textarea v-model="feedbackUpdates[key]" placeholder="Enter feedback"></textarea>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
  
                                </div>
                               
                          </div>
                            <div class="score-override-btns" v-if="editScoreType === 'single' || editScoreType === 'multiple'">
                                <button class="admin-btn-outline-primary" @click="submitReviewerScore">
                                  {{ constants.SUBMIT_BUTTON }}
                                </button>
                                <button class="admin-btn-outline-secondary" @click="cancelEdit">
                                  {{ constants.CANCEL_BUTTON }}
                                </button>
                              </div>
                            
                        
                         
                        </div>
                        
                     
                    </div>
                  </div>
                  <div class="tab-pane fade" id="scoreHistory" role="tabpanel" aria-labelledby="score-history-tab">
                    <div class="score-history-tab-details ai-pop-scroll-out" ref="scrollWrapper" data-simplebar>
                      <div class="ai-pop-scroll"> 
                        <div v-if="scoreHistory.length > 0" class="score-history-box" v-for="historyItem in scoreHistory" :key="historyItem.id">
                          <span class="score-history-date">{{ formatDate(historyItem.date) }}</span>
                          <h4>{{ historyItem.description }}</h4>
                          <span class="score-history-reason">Here's the reason.</span>
                          <div class="score-history-descption">
                            <p>
                              {{ historyItem.reason }}
                            </p>
                          </div>
                      </div>
                      <div v-else class="score-history-descption">
                        <p class="no-data">No score overriden history available.</p>
                      </div>
                    </div>
                     
                    </div>
                  </div>
                  <div class="tab-pane fade" id="scoreResume" role="tabpanel" aria-labelledby="score-resume-tab">
                    <div class="score-resume-tab-details ai-pop-scroll-out" ref="scrollWrapper" data-simplebar>
                      <div class="ai-pop-scroll"> 
                        <div v-if="getResumeSections(selectedCandidate) && Object.keys(getResumeSections(selectedCandidate)).length > 0">
                          <div class="score-resume-box" v-for="(section, key) in getResumeSections(selectedCandidate)" :key="key">
                            <h4>{{ formatSectionKey(key) }}</h4>
                            
                            <!-- Case 1: String value -->
                            <p v-if="typeof section === 'string'">{{ section }}</p>
                            
                            <!-- Case 2: Array of strings -->
                            <div v-else-if="Array.isArray(section) && isArrayOfStrings(section)" class="score-resume-box-skill">
                              <ul>
                                <li v-for="(item, idx) in section" :key="idx">{{ item }}</li>
                              </ul>
                            </div>
                            
                            <!-- Case 3: Array of objects/mixed -->
                            <template v-else-if="Array.isArray(section)">
                              <div v-for="(item, idx) in section" :key="idx">
                                <!-- String item in array -->
                                <p v-if="typeof item === 'string'">{{ item }}</p>
                                
                                <!-- Object item in array -->
                                <div v-else-if="typeof item === 'object' && item !== null" class="score-resume-box-desc">
                                  <template v-for="(value, itemKey) in item" :key="itemKey">
                                    <!-- Nested array of strings -->
                                    <div v-if="Array.isArray(value) && isArrayOfStrings(value)" class="score-resume-box-skill">
                                      <h5>{{ formatSectionKey(itemKey) }}:</h5>
                                      <ul>
                                        <li v-for="(arrItem, arrIdx) in value" :key="arrIdx">{{ arrItem }}</li>
                                      </ul>
                                    </div>
                                    
                                    <!-- Nested array of objects -->
                                    <div v-else-if="Array.isArray(value)">
                                      <h5>{{ formatSectionKey(itemKey) }}:</h5>
                                      <div v-for="(nestedItem, nestedIdx) in value" :key="nestedIdx" class="score-resume-box-desc">
                                        <p v-if="typeof nestedItem === 'string'">{{ nestedItem }}</p>
                                        <template v-else-if="typeof nestedItem === 'object' && nestedItem !== null">
                                          <h5 v-for="(nestedVal, nestedKey) in nestedItem" :key="nestedKey">
                                            {{ nestedVal }}
                                          </h5>
                                        </template>
                                      </div>
                                    </div>
                                    
                                    <!-- Nested object -->
                                    <div v-else-if="typeof value === 'object' && value !== null" class="score-resume-box-desc">
                                      <h5>{{ formatSectionKey(itemKey) }}:</h5>
                                      <h5 v-for="(nestedVal, nestedKey) in value" :key="nestedKey">
                                        {{ nestedVal }}
                                      </h5>
                                    </div>
                                    
                                    <!-- Simple value -->
                                    <h5 v-else-if="value && value !== ''">{{ value }}</h5>
                                  </template>
                                </div>
                              </div>
                            </template>
                            
                            <!-- Case 4: Single object (not array) -->
                            <div v-else-if="typeof section === 'object' && section !== null" class="score-resume-box-desc">
                              <template v-for="(value, objKey) in section" :key="objKey">
                                <!-- Array of strings -->
                                <div v-if="Array.isArray(value) && isArrayOfStrings(value)" class="score-resume-box-skill">
                                  <h5>{{ formatSectionKey(objKey) }}:</h5>
                                  <ul>
                                    <li v-for="(arrItem, arrIdx) in value" :key="arrIdx">{{ arrItem }}</li>
                                  </ul>
                                </div>
                                
                                <!-- Array of objects -->
                                <div v-else-if="Array.isArray(value)">
                                  <h5>{{ formatSectionKey(objKey) }}:</h5>
                                  <div v-for="(arrItem, arrIdx) in value" :key="arrIdx" class="score-resume-box-desc">
                                    <p v-if="typeof arrItem === 'string'">{{ arrItem }}</p>
                                    <template v-else-if="typeof arrItem === 'object' && arrItem !== null">
                                      <h5 v-for="(nestedVal, nestedKey) in arrItem" :key="nestedKey">
                                        {{ nestedVal }}
                                      </h5>
                                    </template>
                                  </div>
                                </div>
                                
                                <!-- Nested object -->
                                <div v-else-if="typeof value === 'object' && value !== null" class="score-resume-box-desc">
                                  <h5>{{ formatSectionKey(objKey) }}:</h5>
                                  <h5 v-for="(nestedVal, nestedKey) in value" :key="nestedKey">
                                    {{ nestedVal }}
                                  </h5>
                                </div>
                                
                                <!-- Simple string/number -->
                                <h5 v-else-if="value && value !== ''">{{ value }}</h5>
                              </template>
                            </div>
                            
                            <!-- Fallback -->
                            <pre v-else>{{ JSON.stringify(section, null, 2) }}</pre>
                          </div>                        
                        </div>
                        <div v-else class="score-resume-box">
                          <p class="no-data">No resume sections available.</p>
                        </div>
                        <div v-if="getMissingDataAnswers(selectedCandidate) && getMissingDataAnswers(selectedCandidate).length > 0" style="margin-bottom: 20px;">
                          <h4 style="margin-bottom: 15px;">Resume Missing Details</h4>
                          <div class="custom-accordion">
                            <div class="custom-accordion-item" 
                              v-for="(answer, idx) in getMissingDataAnswers(selectedCandidate)" 
                              :key="`missing-${idx}`"
                              :class="{ active: activeMissingDataIndex === idx }">
                              <div class="custom-accordion-item-header">
                                <button type="button" class="custom-accordion-item-header-button" @click.prevent="toggleMissingDataAccordion(idx)">
                                  {{ answer.question }}
                                </button>
                              </div>
                              <div class="custom-accordion-item-body">
                                <div class="input-field">
                                    <textarea v-model="answer.answer" rows="2" placeholder="Enter your answer here..."></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="getMissingDataAnswers(selectedCandidate) && getMissingDataAnswers(selectedCandidate).length > 0" style="display: flex; justify-content: center;">
                          <button class="add-btn-admin" @click="saveMissingData">Reproduce AI Score</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="scoreCriteria" role="tabpanel" aria-labelledby="score-criteria-tab">
                    <div class="score-criteria-tab-details " >
                      <div ref="scrollWrapper" class="ai-pop-scroll-out" data-simplebar>
                        <div class="ai-pop-scroll"> 
                        <div v-if="getCriteria(selectedCandidate)">
                          <div v-html="formatCriteriaText(getCriteria(selectedCandidate))"></div>
                          <div class="score-criteria-pop-version">
                           Version : {{ getLatestEvaluation(selectedCandidate)?.criteria_version }}
                          </div>
                          <!-- <div class="score-criteria-pop-last-created">  
                            Last created : {{ formatDate(getLatestEvaluation(selectedCandidate).created_at) }}
                          </div> -->
                        </div>
                        <div v-else class="score-criteria-box">
                          <p class="no-data">No criteria available for this candidate.</p>
                        </div>
                      </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="tab-pane fade" id="scoreAiLog" role="tabpanel" aria-labelledby="score-ai-log-tab">
                    <div class="score-ai-log-tab-details ai-pop-scroll-out" ref="scrollWrapper" data-simplebar>
                      <div class="ai-pop-scroll"> 
                        <template v-if="selectedCandidate && Object.keys(getAiScoreBreakdown(selectedCandidate)).length">
                          <div
                            class="score-criteria-box"
                            v-for="(breakdown, key) in getAiScoreBreakdown(selectedCandidate)"
                            :key="key"
                          >
                            <h4>{{ getBreakdownLabel(key) }}</h4>
                            <div class="score-criteria-box-desc">
                              <p style="font-size: 12px;">{{ breakdown?.reasoning || '' }}</p>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <p class="no-data">No AI logs available.</p>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
		<!-------------------------- AI Score Pop End --------------------------------->

    <!-------------------------- Criteria Pop Start --------------------------------->
    <div class="modal fade criteria-popup" id="criteriaPop" tabindex="-1" role="dialog" aria-labelledby="criteriaModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="criteria-pop-close" data-bs-dismiss="modal"><img src="@/assets/images/admin-img/tags-close-icon.svg" alt="" /></div>
          <div class="criteria-pop-mid">
            <div class="admin-input-field">
              <label class="label-postion">Add Criteria <span>Version : {{ criteriaForm.version }}&nbsp;&nbsp;  Last created : {{ formatDate(criteriaForm.created_at) }}</span></label>
              <textarea placeholder="Enter the Criteria" v-model="criteriaForm.criteria" @input="clearCriteriaError"></textarea>
              <div class="error-msg" v-if="criteriaError">
                {{ criteriaError }}
              </div>
            </div>
            <div class="admin-input-field-submit">
            <button class="admin-btn-outline-primary" @click="openConfirmationModal">
              {{ isSubmittingCriteria ? 'Submitting...' : constants.SUBMIT_BUTTON  }}
              </button>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
		<!-------------------------- Criteria Pop End --------------------------------->

    <!-------------------------- Submit Pop Start --------------------------------->
    <div class="modal fade confirmation-popup" id="confirmationSubmitPop" tabindex="-1" role="dialog" aria-labelledby="confirmationSubmitModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-mid">
            {{ constants.ARE_YOU_SURE_YOU_WANT_TO_CREATE_NEW_VERSION_OF_CRITERIA_TEXT}}
          </div>
          <div class="confirmation-popup-btm">
            <button id="popNoBtn" class="admin-btn-outline-secondary" @click="handleNoClick">
              {{ constants.NO_BUTTON }}
            </button>
            <button id="popYesBtn" class="admin-btn-outline-primary" @click="submitCriteria">
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-------------------------- Submit Pop End --------------------------------->

    <!-------------------------- Reproduce Ai Score Pop Start --------------------------------->
    <div class="modal fade reproduct-aiScore-popup" id="reproductAiScorePopup" tabindex="-1" role="dialog" aria-labelledby="criteriaModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
         
          <div class="pop_header">
             <button class="pop__close__btn" data-bs-dismiss="modal"><img src="@/assets/images/admin-img/tags-close-icon.svg" alt="" /></button>
             <h1>Select any one criteria to reproduce AI Score</h1>
          </div>
          <div class="reproduct-aiScore-pop-mid">
            <div class="reproduct-aiScore-v-list">
                <div v-for="criteria in criteriaVersions" :key="criteria.id" class="reproduct-aiScore-v-list-item">
                  <input type="radio" :id="`version${criteria.version}`" name="criteriaVersion" :value="criteria.id" v-model="selectedCriteriaVersion">
                  <label :for="`version${criteria.version}`">Version {{ criteria.version }}</label>
                </div>
            </div>
            
            <div class="admin-input-field-submit">
              <button class="admin-btn-outline-primary" @click="reproduceAiScores" :disabled="isReproducing">
                 <span v-if="isReproducing">Reproducing...</span>
                 <span v-else>Reproduce</span>
              </button>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
    <!-------------------------- Reproduce Ai Score Pop End --------------------------------->
  </section>
</template>
<script lang="ts">
import { defineComponent, ref, nextTick } from "vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import axios from "axios";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from "sweetalert2";
import SimpleBar from "simplebar";
import { vBTooltip } from "bootstrap-vue-3";
import Tooltip from "bootstrap/js/dist/tooltip";
import moment from "moment";
import { Modal } from "bootstrap";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { environment } from "@/config/environment";
import { API_BASE_URL } from "@/config/api.config";
import Sortable, { SortableEvent } from "sortablejs";
import * as XLSX from "xlsx";
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";
import moment1 from 'moment-timezone';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import Chart from 'chart.js/auto';

interface JoinTeam {
  id: number;
  candidateName: string;
  email: string;
  designation: string;
  description: string;
  candidateImage: string;
  candidateResume: string;
  nameOfReference: string;
  Created_at: string;
  Updated_at: string;
  criteria_version: number;
  resumeSize: number;
  resumeName: string;
  status: number;
  editing?: boolean;
  relativePostDate?: string;
  position: number;
  is_viewed: boolean;
  score_evaluation: Array<{
    scores: Array<{
      [key: string]: {
        score: number;
        score_breakdown: {
          [key: string]: {
            score: number;
            reasoning?: string;
            feedback?: string;
          };
        };
        contributions: Array<{
          name: string;
          score: number;
        }>;
      };
    }>;
    ai_summary: string;
    resume_sections: {
      [key: string]: any;
    };
    criteria: string;
    criteria_version: number;
  }>;
}

interface EmailThread {
  Created_at: string;
  Updated_at: string;
  candidateId: number;
  candidateName: string;
  email: string;
  emailContent: string;
  id: number;
  status: number;
  subject: string;
  relativeEmailPostDate?: string;
  to?: string; 
  isOpen?: boolean;
}

export default defineComponent({
  name: "Join-Team",
  directives: {
    "b-tooltip": vBTooltip,
  },
  data() {
    return {
      // isLoading: false, // Add this
      candidateId: 0,
      constants,
      isCustomDateVisible: false,
      tooltips: [] as Tooltip[],
      errMsg: "",
      errEditMsg: "",
      editor: ClassicEditor,
      activeTab: "all",
      imageSrc: "",
      pendingStatus: "",
      searchTempVar: "",
      editimageSrc: "",
      showAddForm: false,
      limit: 20,
      selectedFile: null as File | null,
      selectedEditFile: null as File | null,
      imageUploaded: false,
      selectAll: false,
      editFormSubmitted: false,
      joinTeams: [] as JoinTeam[],
      editJoinTeamsData: [] as JoinTeam[],
      selectedJoinTeams: [] as number[],
      totalPages: 0,
      currentPage: 1,
      searchedText: "",
      personIdNumber: 0,
      dateFilter: "",
      emailThread: [] as EmailThread[],
      counts: {
        all: 0,
        pending: 0,
        hired: 0,
        rejected: 0,
      } as any,
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "|",
            "outdent",
            "indent",
            "|",
            "undo",
            "redo",
            "|",
            "insertTable",
          ],
        },
      },
      editJoinTeamData: {
        candidateName: "",
        email: "",
        designation: "",
        description: "",
        candidateImage: "",
        nameOfReference: "",
      },
      newEmail: {
        subject: "",
        description: "",
      },
      exportFields: {
        image: false,
        name: false,
        email: false,
        designation: false,
        reference: false,
        description: false,
        status: false,
        date: false,
      },
      joinTeamToDelete: null as number | null,
      joinTeamToDownload: null as number | null,
      deleteMode: "all" as "all" | "single" | "emailThread",
      downloadMode: "all" as "all" | "single",
      showCustomPicker: false,
      showDateDropdown: false,
      showCustomDate: false,
      startDate: "",
      endDate: "",
      isDragging: false, // Added for drag state
      sortableInstance: null as Sortable | null, // Added for SortableJS instance
      selectedJoinTeam: null as number | null, // Track dragged item
      bulkStatusValue: "",
      isBulkUpdate: false,
      originalStatus: 0,
      isSubmitting: false,
      sortBy: '' as string,
      selectAllCandidates: false,
      isExportDropdownOpened: false,
      pollingInterval: null as number | null,
      lastRefreshTime: Date.now(),
      isPolling: false,
      selectAllExportFields : false,
      emailThreadToDelete: null as number | null,
      selectedCandidate: null as JoinTeam | null,
      showStep1: true,
      selectedReasonKey: '',
      activeReviewer: 'AI Score',
      editScoreType: "" as "" | "single" | "multiple",
      editedScore:{
        reviewer_name: '',
        score_breakdown: {} as { [key: string]: { score: number, feedback: string } }
      },
      scoreUpdates: {} as { [key: string]: string },
      feedbackUpdates: {} as { [key: string]: string },
      expandedItems: {} as { [key: string]: boolean },
      scoreErrors: {} as { [key: string]: string },
      reviewerNameError: '',
      criteriaForm: {
        criteria: '',
        version: 1,
        created_at: '',
        originalCriteria: ''
      },
      criteriaError: '',
      isSubmittingCriteria: false,
      isScoreSummaryExpanded: false,
      isOverallScoreExpanded: false,
      overallScoreChart: null as Chart | null,
      criteriaVersions: [] as any[],
      selectedCriteriaVersion: null as number | null,
      isReproducing: false,
      candidatesBeingProcessed: [] as number[],
      processingPollingInterval: null as number | null,
      activeMissingDataIndex: -1,
      isSavingMissingData: false,
    };
  },

  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      next({ name: "Login" });
    } else {
      next();
    }
  },
  computed: {
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    getStatusColor() {
      return (status: any) => {
        switch (status) {
          case 0:
            return { borderColor: "#FDA900", color: "#FDA900" };
          case 1:
            return { borderColor: "#5BC770", color: "#5BC770" };
          case 2:
            return { borderColor: "red", color: "red" };
          case 4:
            return { borderColor: "#BF40BF", color: "#BF40BF" };
          default:
            return { borderColor: "#946CCF", color: "#946CCF" };
        }
      };
    },
    sortedScoreBreakdown() {
      const aiScoreBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
      if (!aiScoreBreakdown) return [];
      return Object.entries(aiScoreBreakdown).sort(
        ([keyA], [keyB]) => {
          const labelA = this.getBreakdownLabel(keyA);
          const labelB = this.getBreakdownLabel(keyB);
          return labelA.localeCompare(labelB);
        }
      );
    },
    availableReviewers() {
      const reviewers = ['AI Score'];
      const reviewerScores = this.getReviewerScores(this.selectedCandidate);
      if (reviewerScores && reviewerScores.length > 0) {
        const reviewerNames = reviewerScores.map(reviewer => reviewer.reviewer);
        reviewers.push(...reviewerNames);
      }
      if (this.getOverallScore(this.selectedCandidate) > 0) {
        reviewers.push('Overall Score');
      }
      return reviewers;
    },
    currentScoreBreakdown(): Array<[string, any]> {
      if (!this.selectedCandidate) {
        return [];
      }
      
      let breakdown = {};
      if (this.activeReviewer === 'AI Score') {
        breakdown = this.getAiScoreBreakdown(this.selectedCandidate);
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              breakdown = scoreItem[this.activeReviewer].score_breakdown || {};
              break;
            }
          }
        }
      }

      return Object.entries(breakdown).sort(([keyA], [keyB]) => {
        const labelA = this.getBreakdownLabel(keyA);
        const labelB = this.getBreakdownLabel(keyB);
        return labelA.localeCompare(labelB);
      });
    },
    scoreHistory() {
      const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
      if (!latestEvaluation || !latestEvaluation.score_history) return [];
      
      // Convert database-stored history to frontend format
      return latestEvaluation.score_history.map((entry: any) => ({
        id: entry.id,
        date: new Date(entry.timestamp),
        reviewer: entry.reviewer,
        category: entry.category,
        categoryLabel: this.getBreakdownLabel(entry.category),
        oldScore: entry.old_score,
        newScore: entry.new_score,
        description: `${this.getBreakdownLabel(entry.category)} score changed from ${entry.old_score} to ${entry.new_score} by ${entry.reviewer}.`,
        reason: entry.reason || 'No reason provided',
      })).sort((a: any, b: any) => b.date.getTime() - a.date.getTime());
    },
    currentScore() {
      if (!this.selectedCandidate) return 0;
      if (this.activeReviewer === 'AI Score') {
        return this.getAiScore(this.selectedCandidate);
      } else if (this.activeReviewer === 'Overall Score') {
        return this.getOverallScore(this.selectedCandidate);
      } else {
        const reviewerScores = this.getReviewerScores(this.selectedCandidate);
        const reviewer = reviewerScores.find(r => r.reviewer === this.activeReviewer);
        return reviewer ? reviewer.score : 0;
      }
    },
    currentScoreText() {
      const score = this.currentScore;
      if (score >= 90) return 'Excellent match';
      if (score >= 70) return 'Good match';
      if (score >= 50) return 'Moderate match';
      if (score >= 30) return 'Weak match';
      return 'Poor match';
    },
    currentScoreColor() {
      const score = this.currentScore;
      if (score >= 80) return 'green';
      if (score >= 60) return 'yellow';
      return 'red';
    },
    displayScoreSummary() {
      const summary = this.getAiSummary(this.selectedCandidate);
      if (!summary) return '';
      if (this.isScoreSummaryExpanded) {
        return summary;
      }
      return summary.length > 150 ? summary.substring(0, 150) + '...' : summary;
    },
    shouldShowReadMore() {
      const summary = this.getAiSummary(this.selectedCandidate);
      return summary && summary.length > 150;
    },
    overallScoreData() {
      console.log('Computing overallScoreData...');
      console.log('selectedCandidate:', this.selectedCandidate);
      
      const overallScore = this.getOverallScore(this.selectedCandidate);
      if (!overallScore || overallScore === 0) {
        console.log('No Overall Score found');
        return null;
      }
      
      // Get the contributions from the Overall Score object
      const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
      if (!latestEvaluation || !latestEvaluation.scores) {
        console.log('No latest evaluation found');
        return null;
      }
      
      let contributions = [];
      for (const scoreItem of latestEvaluation.scores) {
        if (scoreItem['Overall Score']) {
          contributions = scoreItem['Overall Score'].contributions || [];
          break;
        }
      }
      
      if (!contributions || contributions.length === 0) {
        console.log('No contributions found');
        return null;
      }
      
      console.log('Contributions for chart:', contributions);
      
      const result = {
        labels: contributions.map((contrib: any) => contrib.name),
        data: contributions.map((contrib: any) => contrib.score),
        totalScore: overallScore
      };
      
      console.log('Computed overallScoreData:', result);
      return result;
    }
  },
  components: {
    adminHeader,
    adminNavigation,
    Datepicker,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  created() {
    this.limit = getPaginationLimit("joinOurTeam", 20);
    this.fetchCounts();
    this.fetchJoinTeams();
  },
  mounted() {
    const el = this.$refs.scrollWrapper as HTMLElement;
    if (el) {
      new SimpleBar(el);
    }
    this.initializeTooltips();
    this.setupSortable();
    
    // Add event listeners to pause polling during user activity
    document.addEventListener('click', this.pausePollingOnUserActivity);
    document.addEventListener('keydown', this.pausePollingOnUserActivity);
    document.addEventListener('scroll', this.pausePollingOnUserActivity);
    
    // Start polling to detect any ongoing background processes
    this.startPollingIfNeeded();
  },
  watch: {
    activeReviewer(newReviewer, oldReviewer) {
      if (newReviewer !== oldReviewer) {
        this.cancelEdit();
      }
    }
  },
  methods: {
    clearDateFilter() {
      this.dateFilter = "";
      this.startDate = "";
      this.endDate = "";
      this.currentPage = 1;
      this.showCustomPicker = false;
      this.showDateDropdown = false;
      this.showCustomDate = false;
      this.fetchJoinTeams(this.activeTab);
      this.fetchCounts();
    },
    handleDate() {
      if (!this.startDate || !this.endDate) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Date Range",
          text: "Please select both start and end dates.",
          showConfirmButton: true,
        });
        // Reset date filter and fetch unfiltered data
        this.dateFilter = "";
        this.startDate = "";
        this.endDate = "";
        this.fetchJoinTeams(this.activeTab);
        this.fetchCounts();
        this.resetClasses();
        return;
      }

      // Proceed with custom date filter
      this.dateFilter = "custom";
      this.fetchJoinTeams(this.activeTab);
      this.fetchCounts();
      this.resetClasses();
    },
    onRangeStart(value: any) {
      const d = new Date(value);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      this.startDate = `${year}-${month}-${day}`;
    },
    onRangeEnd(value: any) {
      const d = new Date(value);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      this.endDate = `${year}-${month}-${day}`;
    },
    resetClasses() {
      this.showCustomPicker = false;
      this.showDateDropdown = false;
      this.showCustomDate = false;
    },
    formatCustomDate(date: any) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    async getDateFilteredData(dateFilter: any) {
      this.dateFilter = dateFilter;
      this.fetchJoinTeams(this.activeTab);
      this.fetchCounts();
    },
    async fetchJoinTeams(
      status = "all",
      limit?: number,
      skip = 0,
      //@ts-expect-error
      sortBy = this.sortBy
    ) {
      // Use this.limit as the default value if limit is not provided
      const effectiveLimit = limit ?? this.limit;

      let url = `${API_BASE_URL}/candidates/`;
      const params = new URLSearchParams();
      if (status === "pending") {
        params.append("status", "0");
      } else if (status === "hired") {
        params.append("status", "1");
      } else if (status === "rejected") {
        params.append("status", "2");
      }
      if (this.searchedText) {
        if (!this.searchTempVar) {
          this.limit = 20;
          this.currentPage = 1;
        }
        this.searchTempVar = this.searchedText;
      }
      if (!this.searchedText) {
        if (this.searchTempVar) {
          this.currentPage = 1;
          this.limit = 20;
          this.searchTempVar = "";
        }
        params.append("limit", effectiveLimit.toString());
        const skipArticle = (this.currentPage - 1) * effectiveLimit;
        params.append("skip", skipArticle.toString());
      }
      if (this.searchedText) {
        params.append("limit", effectiveLimit.toString());
        params.append("skip", skip.toString());
        params.append("searchedText", this.searchedText);
      }
      if (this.dateFilter) {
        params.append("dateFilter", this.dateFilter);
        if (this.dateFilter === "custom" && this.startDate && this.endDate) {
          params.append("startDate", this.startDate);
          // If same day, append endDate as is; backend will interpret as full day
          params.append("endDate", this.endDate);
        }
      }
      params.append("sort_by", sortBy);

      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.editJoinTeamsData = response.data;
        this.setupSortable(); // Reinitialize SortableJS after data fetch
        // Update selectAll based on whether all current page items are selected
        this.selectAll = this.editJoinTeamsData.every((joinTeam) =>
          this.selectedJoinTeams.includes(joinTeam.id)
        );
      } catch (error) {
        console.error("Error fetching joinTeams:", error);
      }
    },
    async submitForm() {
      if (!this.newEmail.subject || !this.newEmail.description) {
        this.errMsg = "Please Enter Essential Fields.";
        return;
      }
      this.isSubmitting = true;
      try {
        const data = {
          candidateName: this.editJoinTeamData.candidateName,
          email: this.editJoinTeamData.email,
          subject: this.newEmail.subject,
          emailContent: this.newEmail.description,
          candidateId: this.candidateId,
        };
        const response = await fetch(
          `${API_BASE_URL}/candidates-email-threads/send_email/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        await response.json();
        this.resetForm();
        this.errMsg = "";
        (this.$refs.dummyButton as HTMLElement).click();
        Swal.fire({
          icon: "success",
          title: "Email Sent Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        await this.fetchEmailThreads(
          this.candidateId,
          this.editJoinTeamData.email
        );
        // Refresh the candidate list to ensure pagination is maintained
        await this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
      } catch (error) {
        console.error("Error submitting article:", error);
      }finally {
          this.isSubmitting = false; // Re-enable the button
          this.editFormSubmitted = false;
      }
    },
    async fetchEmailThreads(candidateId: number, email: string) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/candidates-email-threads/?candidateId=${candidateId}&email=${email}`
        );
        const data = await response.json() as EmailThread[]; // Cast API response to EmailThread[]
        this.emailThread = data.map((emailThreads: EmailThread) => {
          return {
            ...emailThreads,
            relativeEmailPostDate: moment(emailThreads.Created_at).fromNow(),
            to: emailThreads.to || 'hr@lmdconsulting.com', // Default if API doesn't provide
            isOpen: false // Initialize as collapsed
          };
        });
      } catch (error) {
        console.error(error);
      }
    },
    toggleCollapse(index: number) {
      this.emailThread = this.emailThread.map((thread, i) => ({
        ...thread,
        isOpen: i === index ? !thread.isOpen : thread.isOpen
      }));
    },
    async dummyfunction(index: any, id: any, email: any) {
      await this.markCandidateAsViewed(id);
      this.editJoinTeam(index);
      this.fetchEmailThreads(id, email);
      // Reset all threads to collapsed
      this.emailThread = this.emailThread.map(thread => ({
        ...thread,
        isOpen: false
      }));
    },
    personId(id: number) {
      this.personIdNumber = id;
    },
    onStatusChange(event: Event, candidateId?: number) {
        if (!this.editJoinTeamsData || candidateId === undefined) {
            console.error("editJoinTeamsData is undefined or candidateId is missing");
            return;
        }
      const selectBox = event.target as HTMLSelectElement;
      this.pendingStatus = selectBox.value;
      const candidate = this.editJoinTeamsData.find((joinTeam:any)=>(
        joinTeam.id === candidateId
      ));
      this.originalStatus = candidate ? candidate.status : 0;
      this.personIdNumber = candidateId;
      let modalId = "";
      this.isBulkUpdate = false;
      switch (this.pendingStatus) {
        case "pending":
          modalId = "followupPop";
          break;
        case "hired":
          modalId = "HiredPop";
          break;
        case "rejected":
          modalId = "rejectedPop";
          break;
      }
      if (modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.show();
        }
      }
    },
    updateStatusStyle(status: any) {
      const selectBox = document.getElementById(`statusSelectBox_${this.personIdNumber}`);
      if (selectBox) {
        switch (status) {
          case "pending":
            selectBox.style.borderColor = "#FDA900";
            selectBox.style.color = "#FDA900";
            break;
          case "hired":
            selectBox.style.borderColor = "#5BC770";
            selectBox.style.color = "#5BC770";
            break;
          case "rejected":
            selectBox.style.borderColor = "red";
            selectBox.style.color = "red";
            break;
        }
      }
    },
    async confirmStatusChange(candidateId?: number) {
      try {
        Swal.fire({
          title: "Updating Status...",
          text: "Please wait while the status is being updated.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        if (this.isBulkUpdate) {
          const statusValue = parseInt(this.bulkStatusValue);
          await axios.patch(`${API_BASE_URL}/candidates/bulk-status-update/`, {
            ids: this.selectedJoinTeams,
            status: statusValue,
          });
          this.isBulkUpdate = false;
          this.bulkStatusValue = "";
          this.selectedJoinTeams = [];
          this.selectAll = false;
          this.selectAllCandidates = false;
        } else {
          const updatedStatus = this.pendingStatus;
          let statusValue = 0;
          if (updatedStatus === "pending") {
            statusValue = 0;
          } else if (updatedStatus === "hired") {
            statusValue = 1;
          } else if (updatedStatus === "rejected") {
            statusValue = 2;
          }

          const candidateIndex = this.editJoinTeamsData.findIndex(
            (joinTeam) => joinTeam.id === this.personIdNumber
          );
          if (candidateIndex !== -1) {
            const newJoinTeamsData = [...this.editJoinTeamsData];
            newJoinTeamsData[candidateIndex] = {
              ...newJoinTeamsData[candidateIndex],
              status: statusValue,
            };

            const newCounts = { ...this.counts };
            if (this.editJoinTeamsData[candidateIndex].status !== statusValue) {
              const oldStatus = this.editJoinTeamsData[candidateIndex].status;
              if (oldStatus === 0) newCounts.pending--;
              else if (oldStatus === 1) newCounts.hired--;
              else if (oldStatus === 2) newCounts.rejected--;
              if (statusValue === 0) newCounts.pending++;
              else if (statusValue === 1) newCounts.hired++;
              else if (statusValue === 2) newCounts.rejected++;
              newCounts.all =
                newCounts.pending +
                newCounts.hired +
                newCounts.rejected
            }

            this.editJoinTeamsData = newJoinTeamsData;
            this.counts = newCounts;

            if (
              (this.activeTab === "pending" && statusValue !== 0) ||
              (this.activeTab === "hired" && statusValue !== 1) ||
              (this.activeTab === "rejected" && statusValue !== 2)
            ) {
              this.editJoinTeamsData = newJoinTeamsData.filter(
                (_, index) => index !== candidateIndex
              );
              if (this.editJoinTeamsData.length === 0 && this.currentPage > 1) {
                this.currentPage--;
              }
            }
          }

          this.updateStatusStyle(updatedStatus);

          // Perform backend update first
          const formData = new FormData();
          formData.append("status", statusValue.toString());
          console.log("Form Dat|||||||||||a:", this.personIdNumber);

          await axios.patch(
            `${API_BASE_URL}/candidates/${this.personIdNumber}/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        }
        this.pendingStatus = "";
        Swal.close();
        await Promise.all([
          this.fetchJoinTeams(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          ),
          this.fetchCounts(this.searchedText),
        ]);

        Swal.fire({
          icon: "success",
          title: "Status Updated Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error: any) {
        await Promise.all([
          this.fetchJoinTeams(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          ),
          this.fetchCounts(this.searchedText),
        ]);
        Swal.fire({
          icon: "error",
          title: "Status Update Failed",
          text:
            error?.response?.data.error ||
            "Changes reverted. Please try again.",
          showConfirmButton: true,
        });
      } 
    },
    initializeTooltips() {
      const tooltipElements = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      tooltipElements.forEach((element) => {
        const tooltip = new Tooltip(element);
        this.tooltips.push(tooltip);
      });
    },
    formatDate(date: any) {
      const nyDate = moment1.utc(date).tz("America/New_York");
      return nyDate.format("MMM DD, YYYY h:mm A");
    },
    getRelativeTime(date: any) {
      const nyDate = moment1.utc(date).tz("America/New_York");
      return nyDate.fromNow();
    },
    setDeleteMode(mode: any, joinTeamId?: number, emailThreadId?: number) {
      this.deleteMode = mode;
      if (joinTeamId !== undefined) {
        this.joinTeamToDelete = joinTeamId;
      } else if (emailThreadId !== undefined) {
        this.emailThreadToDelete = emailThreadId;
      }
    },
    downloadResume(mode: any, joinTeamId?: number, joinTeamName?: string) {
      this.downloadMode = mode;
      if (joinTeamId !== undefined) {
        this.joinTeamToDownload = joinTeamId;
      }
      this.confirmDownload(joinTeamName);
    },
    confirmDownload(joinTeamName?: string) {
      if (this.downloadMode === "all") {
        this.downloadSelectedContacts();
      } else if (this.downloadMode === "single") {
        this.downloadJoinTeam(joinTeamName);
      }
    },
    confirmDelete() {
      if (this.deleteMode === "all") {
        this.deleteSelectedContacts();
      } else if (this.deleteMode === "single") {
        this.deleteJoinTeam();
      } else if (this.deleteMode === "emailThread") {
        this.deleteEmailThread();
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        // Do not reset selectedJoinTeams or selectAllCandidates
        this.selectAll = this.editJoinTeamsData.every((joinTeam) =>
          this.selectedJoinTeams.includes(joinTeam.id)
        );
      }
    },
    toggleJoinTeamSelection(joinTeamId: number) {
      if (this.selectedJoinTeams.includes(joinTeamId)) {
        this.selectedJoinTeams = this.selectedJoinTeams.filter((id) => id !== joinTeamId);
        this.selectAll = false; // Uncheck selectAll if any item is deselected
        this.selectAllCandidates = false; // Uncheck selectAllCandidates if any item is deselected
      } else {
        this.selectedJoinTeams.push(joinTeamId);
        // Check if all items on the current page are selected
        this.selectAll = this.editJoinTeamsData.every((joinTeam) =>
          this.selectedJoinTeams.includes(joinTeam.id)
        );
        this.checkSelectAllCandidatesState();
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // If selectAll is checked, select all on the current page
        this.selectedJoinTeams = [
          ...new Set([
            ...this.selectedJoinTeams,
            ...this.editJoinTeamsData.map((joinTeam) => joinTeam.id),
          ]),
        ];
        this.checkSelectAllCandidatesState();
      } else {
        // If selectAll is unchecked, only remove current page items if selectAllCandidates is not active
        if (!this.selectAllCandidates) {
          this.selectedJoinTeams = [];
        } else {
          this.selectedJoinTeams = this.selectedJoinTeams.filter(
            (id) => !this.editJoinTeamsData.map((joinTeam) => joinTeam.id).includes(id)
          );
        }
        this.selectAllCandidates = false;
      }
    },
    async toggleSelectAllCandidates() {
      if (this.selectAllCandidates) {
        try {
          // Fetch all candidate IDs based on current filters
          let url = `${API_BASE_URL}/candidates/`;
          const params = new URLSearchParams();
          if (this.activeTab === "pending") params.append("status", "0");
          else if (this.activeTab === "hired") params.append("status", "1");
          else if (this.activeTab === "rejected") params.append("status", "2");
          if (this.searchedText) params.append("searchedText", this.searchedText);
          if (this.dateFilter) {
            params.append("dateFilter", this.dateFilter);
            if (this.dateFilter === "custom" && this.startDate && this.endDate) {
              params.append("startDate", this.startDate);
              params.append("endDate", this.endDate);
            }
          }
          params.append("fields", "id"); // Only fetch IDs to reduce payload

          const response = await axios.get(`${url}?${params.toString()}`);
          this.selectedJoinTeams = response.data.map((joinTeam: JoinTeam) => joinTeam.id);
          this.selectAll = true; // Also select all on the current page
        } catch (error) {
          console.error("Error fetching all candidate IDs:", error);
          Swal.fire({
            icon: "error",
            title: "Failed to Select All Candidates",
            text: "Unable to fetch candidate IDs. Please try again.",
            showConfirmButton: true,
          });
          this.selectAllCandidates = false; // Revert checkbox state
          this.selectedJoinTeams = [];
          this.selectAll = false;
        }
      } else {
        this.selectedJoinTeams = [];
        this.selectAll = false;
      }
    },
    async deleteSelectedContacts() {
      try {
        await axios.delete(`${API_BASE_URL}/candidates/bulk_delete/`, {
          data: { ids: this.selectedJoinTeams },
        });
        this.editJoinTeamsData = this.editJoinTeamsData.filter(
          (joinTeam) => !this.selectedJoinTeams.includes(joinTeam.id)
        );
        this.selectedJoinTeams = [];
        this.selectAll = false;
        this.selectAllCandidates = false;
        this.fetchCounts();
        this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editJoinTeamsData.length === 0) {
          this.currentPage--;
          if (this.currentPage < 1) {
            this.currentPage = 1;
          }
          this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        Swal.fire({
          icon: "success",
          title: "Candidates Deleted Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error) {
        console.error("Error deleting contacts:", error);
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",
          text: "Unable to delete candidates. Please try again.",
          showConfirmButton: true,
        });
      }
    },
    async downloadSelectedContacts() {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/candidates/download-resumes/`,
          {
            ids: this.selectedJoinTeams,
          },
          {
            responseType: "arraybuffer",
          }
        );
        const blob = new Blob([response.data], { type: "application/zip" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "candidate_resumes.zip";
        link.click();
        this.selectedJoinTeams = [];
        this.selectAll = false;
        this.selectAllCandidates = false;
        await this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.fetchCounts();
      } catch (error) {
        console.error("Error downloading selected contacts:", error);
        Swal.fire({
          icon: "error",
          title: "Download Failed",
          text: "Unable to download resumes. Please try again.",
          showConfirmButton: true,
        });
      }
    },
    handleLimitChange() {
      setPaginationLimit("joinOurTeam", this.limit);
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
      this.fetchJoinTeams(this.activeTab, this.limit);
      this.selectAll = this.editJoinTeamsData.every((joinTeam) =>
        this.selectedJoinTeams.includes(joinTeam.id)
      );
    },
    async switchView(status: string) {
      this.currentPage = 1;
      this.activeTab = status;
      // Only reset selections if selectAllCandidates is not active
      if (!this.selectAllCandidates) {
        this.selectedJoinTeams = [];
        this.selectAll = false;
      }
      this.editFormSubmitted = false;
      await this.fetchJoinTeams(status);
      if (status === "pending") {
        this.totalPages = Math.ceil(this.counts.pending / this.limit);
      } else if (status === "rejected") {
        this.totalPages = Math.ceil(this.counts.rejected / this.limit);
      } else if (status === "hired") {
        this.totalPages = Math.ceil(this.counts.hired / this.limit);
      } else {
        this.totalPages = Math.ceil(this.counts.all / this.limit);
      }
      // Update selectAll based on current page
      this.selectAll = this.editJoinTeamsData.every((joinTeam) =>
        this.selectedJoinTeams.includes(joinTeam.id)
      );
    },
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/candidates/count/`;
        const params = new URLSearchParams();

        // Add searchedText if present
        if (searchedText) {
          params.append("searchedText", searchedText);
        }

        // Add date filter parameters
        if (this.dateFilter) {
          params.append("dateFilter", this.dateFilter);
          if (this.dateFilter === "custom" && this.startDate && this.endDate) {
            params.append("startDate", this.startDate);
            params.append("endDate", this.endDate);
          }
        }

        // Construct base query string
        const baseQuery = params.toString() ? `?${params.toString()}` : "";

        // Log the queries for debugging
        console.log("Count API queries:");

        // API calls for each status count
        const [
          allResponse,
          pendingResponse,
          rejectedResponse,
          hiredResponse,
        ] = await Promise.all([
          // All statuses (0, 1, 2)
          axios
            .get(
              `${baseUrl}${baseQuery}${
                baseQuery ? "&" : "?"
              }status=0&status=1&status=2`
            )
            .then((resp) => {
              console.log(
                "All:",
                `${baseUrl}${baseQuery}${
                  baseQuery ? "&" : "?"
                }status=0&status=1&status=2`,
                resp.data
              );
              return resp;
            }),
          // Pending (status=0)
          axios
            .get(`${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=0`)
            .then((resp) => {
              console.log(
                "Pending:",
                `${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=0`,
                resp.data
              );
              return resp;
            }),
          // Rejected (status=2)
          axios
            .get(`${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=2`)
            .then((resp) => {
              console.log(
                "Rejected:",
                `${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=2`,
                resp.data
              );
              return resp;
            }),
          // Hired (status=1)
          axios
            .get(`${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=1`)
            .then((resp) => {
              console.log(
                "Hired:",
                `${baseUrl}${baseQuery}${baseQuery ? "&" : "?"}status=1`,
                resp.data
              );
              return resp;
            })
        ]);

        this.counts = {
          all: allResponse.data.count || 0,
          pending: pendingResponse.data.count || 0,
          rejected: rejectedResponse.data.count || 0,
          hired: hiredResponse.data.count || 0,
        };

        if (this.activeTab in this.counts) {
          this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
        } else {
          console.error(`Invalid active tab: ${this.activeTab}`);
        }
      } catch (error) {
        console.error("Error fetching joinTeam counts:", error);
      }
    },
    editJoinTeam(index: number) {
      this.editJoinTeamsData.forEach((joinTeam, i) => {
        joinTeam.editing = i === index;
      });
      this.editFormSubmitted = true;
      const selectedJoinTeam = this.editJoinTeamsData[index];
      this.editJoinTeamData = {
        candidateName: selectedJoinTeam.candidateName,
        description: selectedJoinTeam.description,
        email: selectedJoinTeam.email,
        designation: selectedJoinTeam.designation,
        nameOfReference: selectedJoinTeam.nameOfReference,
        candidateImage: selectedJoinTeam.candidateImage || "",
      };
      // Use getCdnImageAddress to ensure proper CDN URL
      this.editimageSrc = selectedJoinTeam.candidateImage
        ? this.getCdnImageAddress(
            selectedJoinTeam.candidateImage,
            "w_160,h_160/"
          )
        : "";
      // Disable SortableJS when editing
      if (this.sortableInstance) {
        this.sortableInstance.option("disabled", true);
      }
    },
    async deleteJoinTeam() {
      try {
        await axios.delete(
          `${API_BASE_URL}/candidates/${this.joinTeamToDelete}/`
        );
        this.editFormSubmitted = false;
        await this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.fetchCounts();
        (this.$refs.dummyButton as HTMLElement).click();
      } catch (error) {
        console.error("Error deleting joinTeam:", error);
      }
    },
    async downloadJoinTeam(joinTeamName?: string) {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/candidates/download-resumes/`,
          {
            ids: [this.joinTeamToDownload],
          },
          { responseType: "blob" }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = this.editJoinTeamsData.find(
          (jt) => jt.id === this.joinTeamToDownload
        )?.resumeName!;
        link.click();
        await this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
      } catch (error) {
        console.error("Error downloading joinTeam:", error);
      }
    },
    getCdnImageAddress(src: string, size: string): string {
      if (!src) return "";
      let cdnUrl: string = environment.imageCdn.getHost;
      cdnUrl = cdnUrl.concat(size);
      return cdnUrl + encodeURIComponent(src);
    },
    async resetForm() {
      this.newEmail.subject = "";
      this.newEmail.description = "";
      this.isSubmitting = false;
      this.editFormSubmitted = false;
      // Only reset selections if selectAllCandidates is not active
      if (!this.selectAllCandidates) {
        this.selectedJoinTeams = [];
        this.selectAll = false;
      }
      // Re-enable SortableJS after resetting form if needed
      if (this.sortableInstance) {
        this.sortableInstance.option("disabled", false);
      }
    },
    setupSortable() {
      nextTick(() => {
        const sortableList = this.$refs.sortableList as HTMLElement;
        if (!sortableList) {
          console.error("Sortable list ref not found!");
          return;
        }

        if (this.sortableInstance) {
          this.sortableInstance.destroy();
        }

        this.sortableInstance = Sortable.create(sortableList, {
          animation: 150,
          draggable: ".admin-item-box",
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          filter:
            ".css-checkbox, button, input, textarea, a, .ck-editor, .ck-content", // Prevent dragging on interactive elements
          preventOnFilter: true,
          disabled: this.editFormSubmitted, // Disable dragging when editing
          onStart: (evt: SortableEvent) => {
            this.isDragging = true;
            this.selectedJoinTeam = this.editJoinTeamsData[evt.oldIndex!].id;
            if (
              ['candidateName', '-candidateName', 'email', '-email', 'designation', '-designation', 'Created_at', '-Created_at', 'Updated_at', '-Updated_at', 'criteria_version', '-criteria_version', 'ai_score', '-ai_score'].includes(
                this.sortBy
              )
            ) {
              evt.preventDefault();
              Swal.fire({
                icon: "warning",
                title: "Cannot Drag",
                text: "First remove sorting then you can be able to drag it.",
                timer: 2000,
                showConfirmButton: false,
              });
              return false;
            }
          },
          onEnd: async (evt: SortableEvent) => {
            this.isDragging = false;
            this.selectedJoinTeam = null;
            const oldIndex = evt.oldIndex!;
            const newIndex = evt.newIndex!;

            if (oldIndex === newIndex) return;

            // Optimistically update local data
            const newJoinTeamsData = [...this.editJoinTeamsData];
            const [movedItem] = newJoinTeamsData.splice(oldIndex, 1);
            newJoinTeamsData.splice(newIndex, 0, movedItem);

            const totalItems = newJoinTeamsData.length;
            newJoinTeamsData.forEach((item, index) => {
                item.position = totalItems - index;
            });
            // Update reactive property
            this.editJoinTeamsData = newJoinTeamsData;

            // Prepare data for backend sync
            const reorderedItems = newJoinTeamsData.map((item) => ({
              id: item.id,
              position: item.position,
            }));

            try {
              await axios.post(`${API_BASE_URL}/candidates/reorder/`, {
                items: reorderedItems,
              });

              // Fetch updated data from server
              await this.fetchJoinTeams(
                this.activeTab,
                this.limit,
                (this.currentPage - 1) * this.limit
              );

              Swal.fire({
                icon: "success",
                title: "Order Updated Successfully!",
                timer: 1500,
                showConfirmButton: false,
              });
            } catch (error) {
              console.error("Error updating order:", error);
              await this.fetchJoinTeams(
                this.activeTab,
                this.limit,
                (this.currentPage - 1) * this.limit
              );
              Swal.fire({
                icon: "error",
                title: "Order Update Failed!",
                text: "Reverted to last saved order.",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          },
        });

        console.log("Sortable instance created:", this.sortableInstance);
      });
    },
    editJoinTeamCancel() {
      // Add this method if you want a cancel button in the edit form
      this.editJoinTeamsData.forEach((joinTeam) => {
        joinTeam.editing = false;
      });
      this.editFormSubmitted = false;
      if (this.sortableInstance) {
        this.sortableInstance.option("disabled", false);
      }
    },
    async exportToExcel() {
        let data = [];
        let url = `${API_BASE_URL}/candidates/`;
        const params = new URLSearchParams();
        if (this.activeTab === "pending") params.append("status", "0");
        else if (this.activeTab === "hired") params.append("status", "1");
        else if (this.activeTab === "rejected") params.append("status", "2");
        params.append('sort_by', this.sortBy);
        try {
            const response = await axios.get(`${url}?${params.toString()}`);
            data = response.data.map(
            (joinTeam: { Created_at: moment.MomentInput }) => {
                return {
                ...joinTeam,
                relativePostDate: moment(joinTeam.Created_at).fromNow(),
                };
            }
            );
        } catch (error) {
            console.error("Error fetching joinTeams:", error);
        }

      // Check if at least one field is selected
      if (!Object.values(this.exportFields).some((field) => field)) {
        Swal.fire({
          icon: "warning",
          title: "No Fields Selected",
          text: "Please select at least one field to export.",
          showConfirmButton: true,
        });
        return;
      }

      // Map status numbers to readable text
      const statusMap: { [key: number]: string } = {
        0: "Pending",
        1: "Hired",
        2: "Rejected",
      };

      // Prepare data for export
      const exportData = data
        // .filter((joinTeam) => this.selectedJoinTeams.includes(joinTeam.id))
        .map((joinTeam:any) => {
          const row: any = {};
         
          if (this.exportFields.name) row["Name"] = joinTeam.candidateName;
          if (this.exportFields.email) row["Email"] = joinTeam.email;
          if (this.exportFields.designation)
            row["Designation"] = joinTeam.designation;
          if (this.exportFields.reference)
            row["Reference"] = joinTeam.nameOfReference;
          if (this.exportFields.description)
            row["Description"] = joinTeam.description;
          if (this.exportFields.status)
            row["Status"] = statusMap[joinTeam.status] || "Unknown";
          if (this.exportFields.date)
            row["Date"] = this.formatDate(joinTeam.Created_at);
          return row;
        });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Calculate dynamic column widths based on content
      const headers = Object.keys(exportData[0] || {});
      const columnWidths = headers.map(header => {
        // Start with header length
        let maxLength = header.length;
        
        // Check all data rows for this column
        exportData.forEach((row:any) => {
          const cellValue = String(row[header] || '');
          // Handle multi-line content by taking the longest line
          const lines = cellValue.split('\n');
          const longestLineLength = Math.max(...lines.map(line => line.length));
          maxLength = Math.max(maxLength, longestLineLength);
        });
        
        // Add some padding and set reasonable min/max limits
        const calculatedWidth = Math.min(Math.max(maxLength + 2, 10), 255);
        return { wch: calculatedWidth };
      });

      // Set column widths
      worksheet["!cols"] = columnWidths;

      // Apply text wrapping and styling to all cells
      const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
      console.log("range", range)
      
      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          
          if (!worksheet[cellAddress]) continue;
          
          // Initialize cell style if it doesn't exist
          if (!worksheet[cellAddress].s) {
            worksheet[cellAddress].s = {};
          }
          
          // Add text wrapping to all cells
          worksheet[cellAddress].s.alignment = {
            wrapText: true,
          };
        }
      }

      // Create workbook and add worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");

      // Generate and download Excel file
      XLSX.writeFile(workbook, "candidates_export.xlsx");

      // Show success message
      Swal.fire({
        icon: "success",
        title: "Export Successful",
        text: "The selected candidates have been exported to Excel.",
        showConfirmButton: false,
        timer: 1500,
      });

     this.isExportDropdownOpened = false;
      this.exportFields = {
        image: false,
        name: false,
        email: false,
        designation: false,
        reference: false,
        description: false,
        status: false,
        date: false,
      };
      this.selectAllExportFields = false;
    },
    async handleBulkStatusChange() {
      if (this.bulkStatusValue === "") {
        Swal.fire({
          icon: "error",
          title: "Status Update Failed!",
          text: "Please select a status.",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      if (this.selectedJoinTeams.length === 0) {
        Swal.fire({
          icon: "error",
          title: "Status Update Failed!",
          text: "Please select at least one candidate.",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      let modalId = "";
      this.isBulkUpdate = true;
      switch (this.bulkStatusValue) {
        case "1":
          this.pendingStatus = "pending";
          modalId = "followupPop";
          break;
        case "1":
          this.pendingStatus = "hired";
          modalId = "HiredPop";
          break;
        case "2":
          this.pendingStatus = "rejected";
          modalId = "rejectedPop";
          break;
      }

      if (modalId) {
        const modalElement = document.getElementById(modalId);
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.show();
        }
      }
    },
    resetStatus(){
        if(this.isBulkUpdate){
            this.bulkStatusValue = "";
            this.isBulkUpdate = false;
        }
        else{
            const candidateIndex = this.editJoinTeamsData.findIndex(
            (joinTeam: any) => joinTeam.id === this.personIdNumber
            );
            if (candidateIndex !== -1) {
            // Revert the status to the original value
            this.editJoinTeamsData[candidateIndex].status = this.originalStatus;

            // Update the select box to reflect the original status
            const statusMap: { [key: number]: string } = {
                0: "pedning",
                1: "hired",
                2: "rejected",
            };
            const selectBox = document.querySelector(
                `#statusSelectBox_${this.personIdNumber}`
            ) as HTMLSelectElement;
            if (selectBox) {
                selectBox.value = statusMap[this.originalStatus] || "pending";
                this.updateStatusStyle(statusMap[this.originalStatus] || "pending");
            }
            }
            this.pendingStatus = "";
            this.personIdNumber = 0;
            this.originalStatus = 0;
        }
    },
    toggleSort(field: string) {
        if (this.sortBy === field) {
            this.sortBy = `-${field}`; 
        } else if (this.sortBy === `-${field}`) {
            this.sortBy = ''; 
        } else {
            this.sortBy = field; 
        }
        this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
    },
    toggleExportDropdown(){
      this.isExportDropdownOpened = !this.isExportDropdownOpened;
    },
    toggleDateDropdown(){
      this.showDateDropdown = !this.showDateDropdown;
    },
    handleOutsideClick(event: MouseEvent) {
      const dropdown = document.querySelector('.export-dropdown');
      const dateFilterDropdown = document.querySelector('.show-date-dropdown');
      const target = event.target as HTMLElement;


      if (this.isExportDropdownOpened && dropdown && !dropdown.contains(target)) {
        this.isExportDropdownOpened = false;
      }

      if (this.showDateDropdown && dateFilterDropdown && !dateFilterDropdown.contains(target)) {
        this.showDateDropdown = false;
      }
    },
    async markCandidateAsViewed(candidateId: number) {
      const candidateIndex = this.editJoinTeamsData.findIndex(
        (joinTeam) => joinTeam.id === candidateId
      );

      if(candidateIndex !== -1 && this.editJoinTeamsData[candidateIndex].status === 0 && !this.editJoinTeamsData[candidateIndex].is_viewed){
        try {
          const response = await axios.patch(
            `${API_BASE_URL}/candidates/${candidateId}/mark-viewed/`,{},{
            headers: { "Content-Type": "application/json" },
          });
          this.editJoinTeamsData[candidateIndex].is_viewed = true;
          await this.fetchJoinTeams(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        } catch (error) {
          console.error("Error marking candidate as viewed:", error);
        }
      }
    },
    toggleSelectAllExportFields() {
      const newValue = this.selectAllExportFields;
      this.exportFields = {
      image: newValue,
      name: newValue,
      email: newValue,
      designation: newValue,
      reference: newValue,
      description: newValue,
      status: newValue,
      date: newValue,
      };
    },
    updateSelectAllExportFields() {
      this.selectAllExportFields = Object.values(this.exportFields).every(
      (field) => field
      );
    },
    hasSameStatus() {
      if (this.selectedJoinTeams.length <= 1) return false; 
      const selectedStatuses = this.editJoinTeamsData
        .filter((joinTeam: any) => this.selectedJoinTeams.includes(joinTeam.id))
        .map((joinTeam: any) => joinTeam.status);
      const uniqueStatuses = new Set(selectedStatuses);
      return uniqueStatuses.size === 1; 
    },
    async deleteEmailThread() {
      try {
        await axios.delete(
          `${API_BASE_URL}/candidates-email-threads/${this.emailThreadToDelete}/`
        );
        await this.fetchJoinTeams(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
      } catch (error) {
        console.error("Error deleting email thread:", error);
      }
    },
    openAiScorePopup(candidate: JoinTeam) {
      this.selectedCandidate = candidate;
      this.activeReviewer = 'AI Score'; 
      this.editedScore.reviewer_name = '';
      this.isScoreSummaryExpanded = false;
      this.activeMissingDataIndex = -1;
      
      // Reset to Score Summary tab when modal opens
      this.$nextTick(() => {
        this.resetToScoreSummaryTab();
      });
    },
    resetToScoreSummaryTab() {
      const scoreOverrideTab = document.getElementById('score-override-tab');
      const scoreHistoryTab = document.getElementById('score-history-tab');
      const scoreResumeTab = document.getElementById('score-resume-tab');
      const scoreCriteriaTab = document.getElementById('score-criteria-tab');
      const scoreAiLogTab = document.getElementById('score-ai-log-tab');
      
      // Remove active class from all tabs
      [scoreOverrideTab, scoreHistoryTab, scoreResumeTab, scoreCriteriaTab, scoreAiLogTab].forEach(tab => {
        if (tab) {
          tab.classList.remove('active');
          tab.setAttribute('aria-selected', 'false');
        }
      });
      
      // Add active class to Score Summary tab
      if (scoreOverrideTab) {
        scoreOverrideTab.classList.add('active');
        scoreOverrideTab.setAttribute('aria-selected', 'true');
      }
      
      // Update tab content visibility
      const scoreOverrideContent = document.getElementById('scoreOverride');
      const scoreHistoryContent = document.getElementById('scoreHistory');
      const scoreResumeContent = document.getElementById('scoreResume');
      const scoreCriteriaContent = document.getElementById('scoreCriteria');
      const scoreAiLogContent = document.getElementById('scoreAiLog');
      
      // Hide all tab content
      [scoreOverrideContent, scoreHistoryContent, scoreResumeContent, scoreCriteriaContent, scoreAiLogContent].forEach(content => {
        if (content) {
          content.classList.remove('show', 'active');
        }
      });
      
      // Show Score Summary content
      if (scoreOverrideContent) {
        scoreOverrideContent.classList.add('show', 'active');
      }
    },
    toggleScoreSummary() {
      this.isScoreSummaryExpanded = !this.isScoreSummaryExpanded;
    },
    getStatusText(status: number | undefined): string {
      if (status === undefined) return 'Unknown';
      switch (status) {
        case 0: return 'Pending';
        case 1: return 'Hired';
        case 2: return 'Rejected';
        default: return 'Unknown';
      }
    },
    getAiScore(candidate: any): number {
      if (!candidate || !candidate.score_evaluation || !Array.isArray(candidate.score_evaluation) || candidate.score_evaluation.length === 0) {
        return 0;
      }
      
      const latestEvaluation = candidate.score_evaluation[candidate.score_evaluation.length - 1];
      const scores = latestEvaluation.scores || [];
      
      for (const scoreItem of scores) {
        if (scoreItem['AI Score']) {
          const aiScore = scoreItem['AI Score'];
          if (Array.isArray(aiScore)) {
            const last = aiScore[aiScore.length - 1];
            return (last && last.score) || 0;
          }
          return (aiScore && aiScore.score) || 0;
        }
      }
      return 0;
    },
    getReviewerScores(candidate: any): any[] {
      if (!candidate || !candidate.score_evaluation || !Array.isArray(candidate.score_evaluation) || candidate.score_evaluation.length === 0) {
        return [];
      }
      
      if (candidate.score_evaluation && Array.isArray(candidate.score_evaluation) && candidate.score_evaluation.length > 0) {
        const latestEvaluation = candidate.score_evaluation[candidate.score_evaluation.length - 1];
        const scores = latestEvaluation.scores || [];
        const reviewerScores = [];
        
        for (const scoreItem of scores) {
          for (const [key, value] of Object.entries(scoreItem)) {
            if (key !== 'AI Score' && key !== 'Overall Score') {
              reviewerScores.push({
                reviewer: key,
                // @ts-ignore
                score: value.score || 0,
                // @ts-ignore
                score_breakdown: value.score_breakdown || {},
                // @ts-ignore
                contributions: value.contributions || []
              });
            }
          }
        }
        return reviewerScores;
      }
      return [];
    },
    getOverallScore(candidate: any): number {
      if (!candidate || !candidate.score_evaluation || !Array.isArray(candidate.score_evaluation) || candidate.score_evaluation.length === 0) {
        return 0;
      }
      
      if (candidate.score_evaluation && Array.isArray(candidate.score_evaluation) && candidate.score_evaluation.length > 0) {
        const latestEvaluation = candidate.score_evaluation[candidate.score_evaluation.length - 1];
        const scores = latestEvaluation.scores || [];
        
        for (const scoreItem of scores) {
          if (scoreItem['Overall Score']) {
            return scoreItem['Overall Score'].score || 0;
          }
        }
      }
      return 0;
    },
    getLatestEvaluation(candidate: any): any {
      if (!candidate || !candidate.score_evaluation || !Array.isArray(candidate.score_evaluation) || candidate.score_evaluation.length === 0) {
        return null;
      }

      // Find the evaluation with the most recent updated_at timestamp
      let latestEvaluation = null;
      let latestTimestamp = '';
      
      for (const evaluation of candidate.score_evaluation) {
        const timestamp = evaluation.updated_at || '';
        if (timestamp > latestTimestamp) {
          latestTimestamp = timestamp;
          latestEvaluation = evaluation;
        }
      }
      
      return latestEvaluation;
    },
    getAiSummary(candidate: any): string {
      const latestEvaluation = this.getLatestEvaluation(candidate);
      return latestEvaluation?.ai_summary || '';
    },
    getResumeSections(candidate: any): any {
      if (candidate?.resume_sections) {
        return candidate.resume_sections;
      }
      
      // Fallback to old structure for backward compatibility
      const latestEvaluation = this.getLatestEvaluation(candidate);
      return latestEvaluation?.resume_sections || {};
    },
    getMissingDataAnswers(candidate: any): any[] {
      // Get missing resume data (questions and answers) provided by candidate
      return candidate?.missing_resume_data || [];
    },
    toggleMissingDataAccordion(index: number) {
      this.activeMissingDataIndex = this.activeMissingDataIndex === index ? -1 : index;
    },
    async saveMissingData() {
      if (!this.selectedCandidate) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No candidate selected'
        });
        return;
      }

      this.isSavingMissingData = true;
      
      const candidatesSnapshot = new Map();
      candidatesSnapshot.set(this.selectedCandidate.id, this.selectedCandidate.Updated_at);
      
      this.candidatesBeingProcessed = [this.selectedCandidate.id];
      
      try {
        const missingData = this.getMissingDataAnswers(this.selectedCandidate);
        
        const response = await axios.patch(
          `${API_BASE_URL}/candidates/${this.selectedCandidate.id}/update-missing-data-and-reproduce/`,
          {
            missing_data: missingData
          }
        );

        if (response.data.success) {
          // Close AI score popup modal if open
          const aiScorePopModalElement = document.getElementById('aiScorePop');
          if (aiScorePopModalElement) {
            const aiScorePopModalInstance = Modal.getInstance(aiScorePopModalElement);
            if (aiScorePopModalInstance) {
              aiScorePopModalInstance.hide();
            }
          }
          
          Swal.fire({
            icon: 'success',
            title: 'Processing Started',
            text: `AI score reproduction started. The score will be updated shortly.`,
            showConfirmButton: false,
            timer: 3000
          });

          this.startProcessingPolling(candidatesSnapshot);
        }
      } catch (error: any) {
        console.error('Error saving missing data:', error);
        this.candidatesBeingProcessed = [];
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.error || 'Failed to save missing data'
        });
      } finally {
        this.isSavingMissingData = false;
      }
    },
    getAiScoreBreakdown(candidate: any): any {
      const latestEvaluation = this.getLatestEvaluation(candidate);
      if (!latestEvaluation || !latestEvaluation.scores) {
        return {};
      }
      
      for (const scoreItem of latestEvaluation.scores) {
        if (scoreItem['AI Score']) {
          const aiScore = scoreItem['AI Score'];
          if (Array.isArray(aiScore)) {
            const last = aiScore[aiScore.length - 1];
            return (last && last.score_breakdown) || {};
          }
          return (aiScore && aiScore.score_breakdown) || {};
        }
      }
      
      if (candidate.score_evaluation && Array.isArray(candidate.score_evaluation)) {
        for (const evaluation of candidate.score_evaluation) {
          if (evaluation.scores) {
            for (const scoreItem of evaluation.scores) {
              if (scoreItem['AI Score']) {
                const aiScore = scoreItem['AI Score'];
                if (Array.isArray(aiScore)) {
                  const last = aiScore[aiScore.length - 1];
                  return (last && last.score_breakdown) || {};
                }
                return (aiScore && aiScore.score_breakdown) || {};
              }
            }
          }
        }
      }
      
      return {};
    },
    getBreakdownLabel(key: string): string {
      return key
        .replace(/[_ ]/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    getOriginalWeight(key: string): number {
      if (!this.selectedCandidate) return 0;
      
      let breakdown: { [key: string]: any } = {};
      if (this.activeReviewer === 'AI Score') {
        breakdown = this.getAiScoreBreakdown(this.selectedCandidate);
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              breakdown = scoreItem[this.activeReviewer].score_breakdown || {};
              break;
            }
          }
        }
      }
      
      return breakdown[key]?.original_weight || 0;
    },
    getWeightedScore(key: string): number {
      if (!this.selectedCandidate) return 0;
      
      let breakdown: { [key: string]: any } = {};
      if (this.activeReviewer === 'AI Score') {
        breakdown = this.getAiScoreBreakdown(this.selectedCandidate);
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              breakdown = scoreItem[this.activeReviewer].score_breakdown || {};
              break;
            }
          }
        }
      }
      
      return breakdown[key]?.weighted_score || 0;
    },
    editSingleScore(key: string) {
      this.selectedReasonKey = key;
      this.showStep1 = false;
      this.editScoreType = "single";
      
      let currentScore = 0;
      let currentFeedback = '';
      
      if (this.activeReviewer === 'AI Score') {
        const aiScoreBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
        currentScore = aiScoreBreakdown?.[key]?.score || 0;
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              currentScore = scoreItem[this.activeReviewer].score_breakdown?.[key]?.score || 0;
              currentFeedback = scoreItem[this.activeReviewer].score_breakdown?.[key]?.feedback || '';
              break;
            }
          }
        }
      }
      
      this.editedScore.score_breakdown[key] = {
        score: currentScore,
        feedback: currentFeedback
      };
      this.editedScore.reviewer_name = this.activeReviewer === "AI Score" ? "" : this.activeReviewer;
    },
    getEditedScore(key: string): number {
      if (!this.editedScore || !this.editedScore.score_breakdown || !key) return 0;
      
      if (this.editedScore.score_breakdown[key]?.score !== undefined) {
        return this.editedScore.score_breakdown[key].score;
      }
      
      if (this.activeReviewer === 'AI Score') {
        const aiScoreBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
        return aiScoreBreakdown?.[key]?.score || 0;
      } else {
        // Find the reviewer in the new structure
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              return scoreItem[this.activeReviewer].score_breakdown?.[key]?.score || 0;
            }
          }
        }
        return 0;
      }
    },
    getEditedFeedback(key: string): string {
      if (!this.editedScore || !this.editedScore.score_breakdown || !key) return '';
      
      if (this.editedScore.score_breakdown[key]?.feedback !== undefined) {
        return this.editedScore.score_breakdown[key].feedback;
      }
      
      if (this.activeReviewer === 'AI Score') {
        const aiScoreBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
        return aiScoreBreakdown?.[key]?.reasoning || '';
      } else {
        // Find the reviewer in the new structure
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              return scoreItem[this.activeReviewer].score_breakdown?.[key]?.feedback || '';
            }
          }
        }
        return '';
      }
    },
    updateEditedScore(key: string, event: Event) {
      if (!this.editedScore || !this.editedScore.score_breakdown || !key) return;
      if (!this.editedScore.score_breakdown[key]) {
        this.editedScore.score_breakdown[key] = { score: 0, feedback: '' };
      }

      const input = event.target as HTMLInputElement;
      const value = input.value;
      
      if (!this.validateScoreInput(key, value)) {
        return;
      }
      
      this.editedScore.score_breakdown[key].score = parseInt(value);
    },
    updateEditedFeedback(key: string, event: Event) {
      if (!this.editedScore || !this.editedScore.score_breakdown || !key) return;
      if (!this.editedScore.score_breakdown[key]) {
        this.editedScore.score_breakdown[key] = { score: 0, feedback: '' };
      }

      const textarea = event.target as HTMLTextAreaElement;
      this.editedScore.score_breakdown[key].feedback = textarea.value || '';
    },
    toggleAccordion(key: string) {
      Object.keys(this.expandedItems).forEach(itemKey => {
        if (itemKey !== key) {
          this.expandedItems[itemKey] = false;
        }
      });
      
      this.expandedItems[key] = !this.expandedItems[key];
    },
    editAllScores() {
      this.selectedReasonKey = '';
      this.showStep1 = false;
      this.editScoreType = "multiple";
      
      this.expandedItems = {};
      this.scoreUpdates = {};
      this.feedbackUpdates = {};
      
      let currentBreakdown = {};
      
      if (this.activeReviewer === 'AI Score') {
        currentBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              currentBreakdown = scoreItem[this.activeReviewer].score_breakdown || {};
              break;
            }
          }
        }
      }
      
      Object.keys(currentBreakdown).forEach(key => {
        this.expandedItems[key] = false;
        // @ts-ignore
        this.scoreUpdates[key] = currentBreakdown[key].score.toString();
        // @ts-ignore
        this.feedbackUpdates[key] = currentBreakdown[key].feedback || '';
      });
      
      if (Object.keys(currentBreakdown).length === 0) {
        const aiBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
        Object.keys(aiBreakdown).forEach(key => {
          this.expandedItems[key] = false;
          // @ts-ignore
          this.scoreUpdates[key] = aiBreakdown[key].score.toString();
          this.feedbackUpdates[key] = '';
        });
      }
      
      this.editedScore.reviewer_name = this.activeReviewer === "AI Score" ? "" : this.activeReviewer;
    },
    cancelEdit() {
      this.showStep1 = true;
      this.selectedReasonKey = '';
      this.editScoreType = "";
      this.scoreUpdates = {};
      this.feedbackUpdates = {};
      this.scoreErrors = {};
      this.reviewerNameError = '';
      this.editedScore = {
        reviewer_name: '',
        score_breakdown: {} as { [key: string]: { score: number, feedback: string } }
      };
      
      // Reset to Score Summary tab when canceling edits
      this.$nextTick(() => {
        this.resetToScoreSummaryTab();
      });
    },
    switchReviewer(reviewerName: string) {
      this.activeReviewer = reviewerName;
      this.editedScore.reviewer_name = reviewerName === 'AI Score' ? '' : reviewerName;
      this.isScoreSummaryExpanded = false; 
      if (reviewerName === 'Overall Score') {
        this.isOverallScoreExpanded = true;
        this.$nextTick(() => {
          this.createOverallScoreChart();
        });
      } else {
        this.isOverallScoreExpanded = false;
        if (this.overallScoreChart) {
          this.overallScoreChart.destroy();
          this.overallScoreChart = null;
        }
      }
      this.cancelEdit();
    },
    validateScoreInput(key: string, value: string): boolean {
      const score = parseInt(value);
      
      if (isNaN(score) || !Number.isInteger(score)) {
        this.scoreErrors[key] = 'Please enter a valid integer.';
        return false;
      }
      
      if (score < 0 || score > 100) {
        this.scoreErrors[key] = 'Score must be between 0 and 100.';
        return false;
      }
      
      delete this.scoreErrors[key];
      return true;
    },
    updateScoreInput(key: string, event: Event) {
      const input = event.target as HTMLInputElement;
      const value = input.value;
      
      if (this.validateScoreInput(key, value)) {
        this.scoreUpdates[key] = value;
      } else {
        input.value = this.scoreUpdates[key];
      }
    },
    validateReviewerName(name: string): boolean {
      if (!name || name.trim() === '') {
        this.reviewerNameError = 'Please enter a valid interviewer name.';
        return false;
      }

      if (name.toLowerCase() === 'ai score') {
        this.reviewerNameError = `Cannot use "${name}" as interviewer name. Please use a different name.`;
        return false;
      }

      const reviewerScores = this.getReviewerScores(this.selectedCandidate);
      const existingReviewer = reviewerScores.find(r => r.reviewer === name);
      
      if (this.activeReviewer !== 'AI Score' && existingReviewer) {
        if (this.activeReviewer !== name) {
          this.reviewerNameError = `Cannot edit score for reviewer "${name}". You can only edit your own scores.`;
          return false;
        }
      }
      
      if (existingReviewer && this.activeReviewer === 'AI Score') {
        this.reviewerNameError = `Score with interviewer name "${name}" has already been given. Please use a different name or edit the existing score.`;
        return false;
      }
      
      this.reviewerNameError = '';
      return true;
    },
    buildScoreBreakdown(): any {
      const breakdown: any = {};
      
      if (this.activeReviewer === 'AI Score') {
        const aiBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
        Object.keys(aiBreakdown).forEach(key => {
          breakdown[key] = {
            score: aiBreakdown[key].score,
            feedback: ''
          };
        });
      } else {
        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        if (latestEvaluation && latestEvaluation.scores) {
          for (const scoreItem of latestEvaluation.scores) {
            if (scoreItem[this.activeReviewer]) {
              const existingBreakdown = scoreItem[this.activeReviewer].score_breakdown || {};
              Object.keys(existingBreakdown).forEach(key => {
                breakdown[key] = {
                  score: existingBreakdown[key].score,
                  feedback: existingBreakdown[key].feedback || ''
                };
              });
              break;
            }
          }
        }

        // Fallback to AI breakdown if reviewer has no prior breakdown
        if (Object.keys(breakdown).length === 0) {
          const aiBreakdown = this.getAiScoreBreakdown(this.selectedCandidate);
          Object.keys(aiBreakdown).forEach(key => {
            breakdown[key] = {
              score: aiBreakdown[key].score,
              feedback: ''
            };
          });
        }
      }
      
      if (this.editScoreType === 'single') {
        const key = this.selectedReasonKey;
        if (key) {
          breakdown[key] = {
            score: this.getEditedScore(key),
            feedback: this.getEditedFeedback(key) || ''
          };
        }
      } else if (this.editScoreType === 'multiple') {
        Object.keys(this.scoreUpdates).forEach(key => {
          const newScore = parseFloat(this.scoreUpdates[key]) || 0;
          
          breakdown[key] = {
            score: newScore,
            feedback: this.feedbackUpdates[key] || ''
          };
        });
      }
      
      return breakdown;
    },
    
    buildMultipleScoreBreakdown(): any {
      const breakdown: any = {};
      
      Object.keys(this.scoreUpdates).forEach(key => {
        const newScore = parseFloat(this.scoreUpdates[key]) || 0;
        
        breakdown[key] = {
          score: newScore,
          feedback: this.feedbackUpdates[key] || ''
        };
      });
      
      return breakdown;
    },
    calculateTotalScore(breakdown: any): number {
      const scores = Object.values(breakdown).map((item: any) => item.score || 0);
      return Math.floor(scores.reduce((sum: number, score: number) => sum + score, 0) / scores.length);
    },
    async submitReviewerScore() {
      this.reviewerNameError = '';
      this.scoreErrors = {};
      if (!this.validateReviewerName(this.editedScore.reviewer_name)) return;
      if (!this.selectedCandidate) { return; }

      try {
        let scoreBreakdown;
        
        if (this.editScoreType === 'multiple') {
          scoreBreakdown = this.buildMultipleScoreBreakdown();
        } else {
          scoreBreakdown = this.buildScoreBreakdown();
        }

        const latestEvaluation = this.getLatestEvaluation(this.selectedCandidate);
        const criteria_version = latestEvaluation?.criteria_version;

        const response = await axios.patch(
          `${API_BASE_URL}/candidates/${this.selectedCandidate.id}/reviewer-scores/`,
          {
            reviewer_name: this.editedScore.reviewer_name,
            score_breakdown: scoreBreakdown,
            criteria_version
          }
        );

        const updatedCandidate = await axios.get(`${API_BASE_URL}/candidates/${this.selectedCandidate.id}/`);
        this.selectedCandidate = updatedCandidate.data;

        this.activeReviewer = (this.editedScore.reviewer_name || '').trim();

        this.cancelEdit();
        this.isOverallScoreExpanded = false;

        Swal.fire({
          icon: 'success',
          title: 'Score Updated Successfully!',
          showConfirmButton: false,
          timer: 1500
        });
      } catch (error: any) {
        console.error('Error updating reviewer score:', error);
        this.reviewerNameError = error.response?.data?.error || 'Failed to update score. Please try again.';
      }
    },
    formatSectionKey(key: any) {
      return key
        .replace(/[_]/g, ' ') 
        .replace(/\b\w/g, (char: any) => char.toUpperCase()); 
    },
    isArrayOfStrings(arr: any) {
      return arr.every((item: any) => typeof item === 'string');
    },
    createOverallScoreChart() {
      console.log('Creating overall score chart...');
      console.log('overallScoreData:', this.overallScoreData);
      
      if (!this.overallScoreData) {
        console.log('No overall score data available');
        return;
      }
      
      const ctx = this.$refs.overallScoreChart as HTMLCanvasElement;
      console.log('Canvas element:', ctx);
      
      if (!ctx) {
        console.log('Canvas element not found');
        return;
      }
      
      if (this.overallScoreChart) {
        this.overallScoreChart.destroy();
      }
      
      const { labels, data, totalScore } = this.overallScoreData;
      console.log('Chart data:', { labels, data, totalScore });
      
      const generateColors = (count: number) => {
        const baseColors = [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
          '#9966FF', '#FF9F40', '#FF6384', '#C9CBCF',
          '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
          '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F'
        ];
        
        if (count <= baseColors.length) {
          return baseColors.slice(0, count);
        }
        
        const colors = [...baseColors];
        for (let i = baseColors.length; i < count; i++) {
          const hue = (i * 137.5) % 360; 
          colors.push(`hsl(${hue}, 70%, 60%)`);
        }
        
        return colors;
      };
      
      const colors = generateColors(labels.length);
      
      // @ts-ignore
      this.overallScoreChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 2
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'center',
              labels: {
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 8,
                boxHeight: 8,
                font: {
                  size: 12
                }
              }
            },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  return `${label}: ${value}%`;
                }
              }
            }
          },
          cutout: '60%',
          elements: {
            arc: {
              borderWidth: 2
            }
          },
          layout: {
            padding: {
              right: 20
            }
          }
        }
      });
      
      console.log('Chart created successfully:', this.overallScoreChart);
    },
    getScoreColor(score: number): { background: string, progress: string } {
      if (score >= 80) return { background: '#d2fbe6', progress: '#10b980' }; 
      if (score >= 60) return { background: '#ffe69b', progress: '#ffc107' };
      return { background: '#ffb5bc', progress: '#dc3545' }; 
    },
    async openCriteriaModal() {
      try {
        const response = await axios.get(`${API_BASE_URL}/criteria/latest/`);
        const latestCriteria = response.data; 
        this.criteriaForm = {
          criteria: latestCriteria.criteria || '',
          version: latestCriteria.version || 1,
          created_at: latestCriteria.created_at || '',
          originalCriteria: latestCriteria.criteria || '' 
        };
        this.criteriaError = '';
      } catch (error) {
        console.error('Error fetching criteria:', error);
        this.resetCriteriaForm();
        // this.criteriaError = 'Error loading existing criteria.';
      }
    },
    validateCriteriaWeights(criteria: string): { isValid: boolean; error: string } {
      try {
        // Parse the criteria text to extract weights
        const lines = criteria.split('\n');
        const weightPattern = /\((\d+)\s*points?\)/gi;
        let totalWeight = 0;
        const foundWeights: number[] = [];

        for (const line of lines) {
          const matches = line.match(weightPattern);
          if (matches) {
            for (const match of matches) {
              const weight = parseInt(match.replace(/[^\d]/g, ''));
              if (!isNaN(weight)) {
                foundWeights.push(weight);
                totalWeight += weight;
              }
            }
          }
        }

        // Check if any weights were found
        if (foundWeights.length === 0) {
          return {
            isValid: false,
            error: 'No weights found in criteria. Please ensure each category has a weight specified (e.g., "25 points").'
          };
        }

        // Check if total equals 100
        if (totalWeight !== 100) {
          return {
            isValid: false,
            error: `Total weight must be 100. Current total: ${totalWeight}.`
          };
        }

        return {
          isValid: true,
          error: ''
        };

      } catch (error) {
        return {
          isValid: false,
          error: 'Error parsing criteria weights. Please check the format and try again.'
        };
      }
    },
    async submitCriteria() {
      const confirmationModalElement = document.getElementById('confirmationSubmitPop');
      if (confirmationModalElement) {
        const confirmationModalInstance = Modal.getInstance(confirmationModalElement);
        if (confirmationModalInstance) {
          confirmationModalInstance.hide();
        }
      }

      const trimmedCriteria = this.criteriaForm.criteria.trim();
      
      // Clear any previous errors
      this.criteriaError = '';
      
      // Validate that the sum of weights equals 100
      const weightValidationResult = this.validateCriteriaWeights(trimmedCriteria);
      if (!weightValidationResult.isValid) {
        this.criteriaError = weightValidationResult.error;
        const modalElement = document.getElementById('criteriaPop');
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.show();
        }
        return;
      }
      
      this.isSubmittingCriteria = true;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/criteria/`,
          {
            criteria: trimmedCriteria
          },
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );
        console.log('response', response);
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: `New criteria version ${response.data.version} created successfully`,
          showConfirmButton: false,
          timer: 1500
        });

        this.criteriaForm = {
          criteria: response.data.criteria,
          version: response.data.version,
          created_at: response.data.created_at,
          originalCriteria: response.data.criteria
        };
        
        const modalElement = document.getElementById('criteriaPop');
        if (modalElement) {
          const modalInstance = Modal.getInstance(modalElement);
          if (modalInstance) {
            modalInstance.hide();
          }
        }
      } catch (error: any) {
        console.error('Error submitting criteria:', error);
        
        if (error.response?.data?.errors) {
          const errors = error.response.data.errors;
          if (errors.criteria) {
            this.criteriaError = Array.isArray(errors.criteria) ? errors.criteria[0] : errors.criteria;
          } else {
            this.criteriaError = 'Please check your input and try again.';
          }
        } else if (error.response?.data?.message) {
          this.criteriaError = error.response.data.message;
        } else {
          this.criteriaError = 'An error occurred while saving criteria. Please try again.';
        }
        
        const modalElement = document.getElementById('criteriaPop');
        if (modalElement) {
          const modalInstance = new Modal(modalElement);
          modalInstance.show();
        }
      } finally {
        this.isSubmittingCriteria = false;
      }
    },
    clearCriteriaError() {
      this.criteriaError = '';
    },
    resetCriteriaForm() {
      this.criteriaForm = {
        criteria: '',
        version: 1,
        created_at: '',
        originalCriteria: ''
      };
      this.criteriaError = '';
    },
    openConfirmationModal() {
      this.criteriaError = '';
      
      if (!this.criteriaForm.criteria || this.criteriaForm.criteria.trim() === '') {
        this.criteriaError = 'Please enter criteria before submitting.';
        return;
      }

      const trimmedCriteria = this.criteriaForm.criteria.trim();
      if (trimmedCriteria === this.criteriaForm.originalCriteria) {
        Swal.fire({
          icon: 'info',
          title: 'No Changes',
          text: 'Criteria text is same as latest version. No new version created.',
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }

      const criteriaModalElement = document.getElementById('criteriaPop');
      if (criteriaModalElement) {
        const criteriaModalInstance = Modal.getInstance(criteriaModalElement);
        if (criteriaModalInstance) {
          criteriaModalInstance.hide();
        }
      }
      
      const modalElement = document.getElementById('confirmationSubmitPop');
      if (modalElement) {
        const modalInstance = new Modal(modalElement);
        modalInstance.show();
      }
    },
    handleNoClick() {
      const confirmationModalElement = document.getElementById('confirmationSubmitPop');
      if (confirmationModalElement) {
        const confirmationModalInstance = Modal.getInstance(confirmationModalElement);
        if (confirmationModalInstance) {
          confirmationModalInstance.hide();
        }
      }
      
      const criteriaModalElement = document.getElementById('criteriaPop');
      if (criteriaModalElement) {
        const criteriaModalInstance = new Modal(criteriaModalElement);
        criteriaModalInstance.show();
      }
    },
    getCriteria(candidate: any): string {
      const latestEvaluation = this.getLatestEvaluation(candidate);
      return latestEvaluation?.criteria || '';
    },
    formatCriteriaText(criteria: string): string {
      if (!criteria) return '';
      
      const lines = criteria.split('\n').filter(line => line.trim());
      let formatted = '';
      let currentBox = '';
      
      lines.forEach(line => {
        if (line.match(/^\d+\./)) {
          if (currentBox) {
            formatted += currentBox + '</div></div>';
          }
          
          currentBox = `<div class="score-criteria-box">
            <h4>${line.trim()}</h4>
            <div class="score-criteria-box-desc">`;
        } else if (line.startsWith('-')) {
          if (currentBox) {
            currentBox += `<ul><li>${line.trim().substring(1).trim()}</li></ul>`;
          }
        } else if (line.trim() && !line.startsWith('-')) {
          if (currentBox) {
            currentBox += `<p>${line.trim()}</p>`;
          }
        }
      });
      
      if (currentBox) {
        formatted += currentBox + '</div></div>';
      }
      
      return formatted;
    },
    async openReproduceModal() {
      try {
        await this.fetchCriteriaVersions();
      } catch (error) {
        console.error('Error opening reproduce modal:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load criteria versions',
          showConfirmButton: false,
          timer: 2000
        });
      }
    },
    async fetchCriteriaVersions() {
      try {
        const response = await axios.get(`${API_BASE_URL}/criteria/`);
        this.criteriaVersions = response.data;
        console.log('Fetched criteria versions:', this.criteriaVersions);
      } catch (error) {
        console.error('Error fetching criteria versions:', error);
        throw error;
      }
    },
    async reproduceAiScores() {
      if (!this.selectedCriteriaVersion) {
        Swal.fire({
          icon: 'warning',
          title: 'No Criteria Selected',
          text: 'Please select a criteria version to reproduce AI scores',
          showConfirmButton: false,
          timer: 2000
        });
        return;
      }
      
      if (this.selectedJoinTeams.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'No Candidates Selected',
          text: 'Please select at least one candidate to reproduce AI scores',
          showConfirmButton: false,
          timer: 2000
        });
        return;
      }
      
      this.isReproducing = true;
      
      // Store current Updated_at timestamps for selected candidates
      const candidatesSnapshot = new Map();
      for (const candidateId of this.selectedJoinTeams) {
        const candidate = this.editJoinTeamsData.find(c => c.id === candidateId);
        if (candidate) {
          candidatesSnapshot.set(candidateId, candidate.Updated_at);
        }
      }
      
      // Track which candidates are being processed
      this.candidatesBeingProcessed = [...this.selectedJoinTeams];
      
      try {
        const response = await axios.post(`${API_BASE_URL}/candidates/reproduce-ai-score/`, {
          criteria_id: this.selectedCriteriaVersion,
          candidate_ids: this.selectedJoinTeams
        });
        
        Swal.fire({
          icon: 'success',
          title: 'Processing Started',
          text: response.data.message || `AI score reproduction started for ${this.selectedJoinTeams.length} candidates in criteria version ${response.data.criteria_version}`,
          showConfirmButton: false,
          timer: 3000
        });
        
        const reproductAiScorePopupModalElement = document.getElementById('reproductAiScorePopup');
        if (reproductAiScorePopupModalElement) {
          const reproductAiScorePopupModalInstance = Modal.getInstance(reproductAiScorePopupModalElement);
          if (reproductAiScorePopupModalInstance) {
            reproductAiScorePopupModalInstance.hide();
          }
        }
        
        this.selectedCriteriaVersion = null;
        this.selectedJoinTeams = [];
        this.selectAll = false;
        this.selectAllCandidates = false;
        
        // Start polling to detect when AI score reproduction completes
        this.startProcessingPolling(candidatesSnapshot);
        
      } catch (error) {
        console.error('Error reproducing AI scores:', error);
        this.candidatesBeingProcessed = [];
        Swal.fire({
          icon: 'error',
          title: 'Reproduction Failed',
          text: 'Failed to reproduce AI scores. Please try again.',
          showConfirmButton: false,
          timer: 3000
        });
      } finally {
        this.isReproducing = false;
      }
    },
    closeReproduceModal() {
      this.selectedCriteriaVersion = null;
      this.selectedJoinTeams = [];
      this.isReproducing = false;
      this.selectAll = false;
      this.selectAllCandidates = false;
    },
    async checkSelectAllCandidatesState() {
      try {
        let url = `${API_BASE_URL}/candidates/`;
        const params = new URLSearchParams();
        if (this.activeTab === "pending") params.append("status", "0");
        else if (this.activeTab === "hired") params.append("status", "1");
        else if (this.activeTab === "rejected") params.append("status", "2");
        if (this.searchedText) params.append("searchedText", this.searchedText);
        if (this.dateFilter) {
          params.append("dateFilter", this.dateFilter);
          if (this.dateFilter === "custom" && this.startDate && this.endDate) {
            params.append("startDate", this.startDate);
            params.append("endDate", this.endDate);
          }
        }
        params.append("fields", "id"); 

        const response = await axios.get(`${url}?${params.toString()}`);
        const allCandidateIds = response.data.map((joinTeam: JoinTeam) => joinTeam.id);
        
        this.selectAllCandidates = allCandidateIds.every((id: any) => this.selectedJoinTeams.includes(id));
      } catch (error) {
        console.error("Error checking select all candidates state:", error);
        this.selectAllCandidates = false;
      }
    },
    startPolling() {
      // Don't start polling if already running
      if (this.isPolling) return;
      
      this.isPolling = true;
      console.log('Starting polling for status changes...');
      
      // Poll every 3 seconds
      this.pollingInterval = setInterval(async () => {
        try {
          await this.checkForStatusChanges();
        } catch (error) {
          console.error('Error during polling:', error);
        }
      }, 3000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
        this.isPolling = false;
        console.log('Stopped polling for status changes.');
      }
    },
    async checkForStatusChanges() {
      try {
        // Get current candidates data
        const response = await axios.get(`${API_BASE_URL}/candidates/`, {
          params: {
            limit: this.limit,
            skip: (this.currentPage - 1) * this.limit,
            ...(this.activeTab === "pending" && { status: 0 }),
            ...(this.activeTab === "hired" && { status: 1 }),
            ...(this.activeTab === "rejected" && { status: 2 }),
            sort_by: this.sortBy,
          }
        });
        
        const newData = response.data;
        const currentData = this.editJoinTeamsData;
        
        // Check if there are any changes in candidate statuses or new candidates
        let hasChanges = false;
        
        // Check for new candidates or status changes
        if (newData.length !== currentData.length) {
          hasChanges = true;
        } else {
          for (let i = 0; i < newData.length; i++) {
            const newCandidate = newData[i];
            const currentCandidate = currentData[i];
            
            if (!currentCandidate || 
                newCandidate.id !== currentCandidate.id || 
                newCandidate.status !== currentCandidate.status ||
                newCandidate.Created_at !== currentCandidate.Created_at) {
              hasChanges = true;
              break;
            }
          }
        }
        
        // Check if any candidates being processed have been updated (before refreshing)
        let shouldNavigateToFirstPage = false;
        if (this.candidatesBeingProcessed.length > 0) {
          const processedCandidates = newData.filter((candidate: any) => {
            if (!this.candidatesBeingProcessed.includes(candidate.id)) {
              return false;
            }
            
            // Find the old candidate data
            const oldCandidate = currentData.find((c: any) => c.id === candidate.id);
            
            // Check if Updated_at has changed or AI score exists
            if (oldCandidate) {
              const hasUpdatedAt = candidate.Updated_at !== oldCandidate.Updated_at;
              const hasAiScore = this.getAiScore(candidate) > 0;
              return hasUpdatedAt || hasAiScore;
            }
            
            // If new candidate has AI score, consider it processed
            return this.getAiScore(candidate) > 0;
          });
          
          if (processedCandidates.length > 0) {
            console.log(`Removing ${processedCandidates.length} processed candidates from spinner list`);
            this.candidatesBeingProcessed = this.candidatesBeingProcessed.filter(
              id => !processedCandidates.some((c: any) => c.id === id)
            );
            
            // Navigate to first page to show newly processed candidates at the top
            if (this.currentPage !== 1) {
              shouldNavigateToFirstPage = true;
              console.log('Navigating to page 1 to show newly processed candidates');
            }
          }
        }
        
        // If there are changes, refresh the data
        if (hasChanges || shouldNavigateToFirstPage) {
          console.log('Status changes detected, refreshing data...');
          
          // Navigate to page 1 if we detected processed candidates
          if (shouldNavigateToFirstPage) {
            this.currentPage = 1;
            await this.fetchJoinTeams(this.activeTab, this.limit, 0);
          } else {
            await this.fetchJoinTeams(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
          }
          
          await this.fetchCounts();
          this.lastRefreshTime = Date.now();
        }
        
        // Stop polling if no candidates are being processed (optimization)
        if (this.candidatesBeingProcessed.length === 0) {
          console.log('No candidates being processed, stopping polling...');
          this.stopPolling();
        }
        
      } catch (error) {
        console.error('Error checking for status changes:', error);
        // Stop polling on repeated errors
        this.stopPolling();
      }
    },
    // Method to start polling when needed
    startPollingIfNeeded() {
      // Start polling if there might be evaluating candidates
      // This is called after certain actions that might trigger background processes
      setTimeout(() => {
        this.startPolling();
      }, 1000); // Wait 2 seconds before starting to poll
    },
    // Stop polling when user is actively interacting
    pausePollingOnUserActivity() {
      if (this.isPolling) {
        this.stopPolling();
        // Resume polling after 30 seconds of inactivity
        setTimeout(() => {
          if (!this.isPolling) {
            this.startPollingIfNeeded();
          }
        }, 30000);
      }
    },
    startProcessingPolling(candidatesSnapshot: Map<number, string>) {
      if (this.processingPollingInterval) {
        clearInterval(this.processingPollingInterval);
      }
      
      console.log('Starting polling for AI score reproduction...');
      
      let pollCount = 0;
      const maxPolls = 120; // Poll for max 10 minutes (120 * 5 seconds)
      
      this.processingPollingInterval = setInterval(async () => {
        pollCount++;
        
        try {
          // Fetch latest data for candidates being processed
          const response = await axios.get(`${API_BASE_URL}/candidates/`, {
            params: {
              limit: 1000, // Get enough to include all candidates
              skip: 0,
              sort_by: '-Updated_at'
            }
          });
          
          const allCandidates = response.data;
          const processedCandidates: number[] = [];
          
          // Check each candidate being processed
          for (const candidateId of this.candidatesBeingProcessed) {
            const latestCandidate = allCandidates.find((c: any) => c.id === candidateId);
            
            if (latestCandidate) {
              const originalUpdatedAt = candidatesSnapshot.get(candidateId);
              
              // Check if Updated_at has changed
              if (originalUpdatedAt && latestCandidate.Updated_at !== originalUpdatedAt) {
                console.log(`Candidate ${candidateId} AI score reproduction completed`);
                processedCandidates.push(candidateId);
              }
            }
          }
          
          // Remove processed candidates from tracking list
          if (processedCandidates.length > 0) {
            this.candidatesBeingProcessed = this.candidatesBeingProcessed.filter(
              id => !processedCandidates.includes(id)
            );
            
            console.log(`${processedCandidates.length} candidates completed. Remaining: ${this.candidatesBeingProcessed.length}`);
          }
          
          // If all candidates are processed, navigate to page 1
          if (this.candidatesBeingProcessed.length === 0) {
            console.log('All candidates processed! Navigating to page 1...');
            
            // Stop polling
            if (this.processingPollingInterval) {
              clearInterval(this.processingPollingInterval);
              this.processingPollingInterval = null;
            }
            
            // Navigate to page 1 of active tab
            this.currentPage = 1;
            await this.fetchJoinTeams(this.activeTab, this.limit, 0);
            await this.fetchCounts();
            
            Swal.fire({
              icon: 'success',
              title: 'Processing Completed',
              text: 'AI score reproduction completed',
              showConfirmButton: false,
              timer: 2000
            });
          }
          
          // Stop polling after max attempts
          if (pollCount >= maxPolls) {
            console.log('Max polling attempts reached');
            if (this.processingPollingInterval) {
              clearInterval(this.processingPollingInterval);
              this.processingPollingInterval = null;
            }
            this.candidatesBeingProcessed = [];
          }
          
        } catch (error) {
          console.error('Error during processing polling:', error);
        }
      }, 5000); // Poll every 5 seconds
    },
    stopProcessingPolling() {
      if (this.processingPollingInterval) {
        clearInterval(this.processingPollingInterval);
        this.processingPollingInterval = null;
        console.log('Stopped processing polling');
      }
    }
  },
  beforeUnmount() {
    if (this.overallScoreChart) {
      this.overallScoreChart.destroy();
    }
    // Clean up polling intervals
    this.stopPolling();
    this.stopProcessingPolling();
    
    // Remove event listeners
    document.removeEventListener('click', this.pausePollingOnUserActivity);
    document.removeEventListener('keydown', this.pausePollingOnUserActivity);
    document.removeEventListener('scroll', this.pausePollingOnUserActivity);
  }
});
</script>



